export const work = {
  offlineMove: {
    saved: "Guardado, se enviará cuando tenga conexión.",
  },
  whoWhen: {
    who: "Quién",
    when: "Cuándo",
    whenPlaceholder: "Elige un día",
    change: "Cambiar",
    applyToAll: "Aplicar a todos",
    done: "Listo",
    pickContractorTitle: "Elige un contratista",
    pickContractorsTitle: "Elige a qué contratistas pedir presupuesto",
    summary: {
      person: "Lo hace {{name}}",
      teamQueue: "Tu equipo, aún sin persona",
      contractor: "Lo hace {{name}}",
      pickContractor: "Elige un contratista",
      pickContractors: "Elige a qué contratistas pedir presupuesto",
      quotes_one: "Pedir presupuesto a {{count}} contratista",
      quotes_other: "Pedir presupuesto a {{count}} contratistas",
      quotes_many: "Pedir presupuesto a {{count}} contratistas",
    },
    sheetTitle: "Crear trabajo",
    title: "Título",
    brief: "Descripción",
    moreDetails: "Más detalles",
    create: "Crear",
    created: "Trabajo creado y entregado",
    quotesSent_one: "Trabajo creado. Solicitud de presupuesto enviada a {{count}} contratista",
    quotesSent_other: "Trabajo creado. Solicitudes de presupuesto enviadas a {{count}} contratistas",
    quotesSent_many: "Trabajo creado. Solicitudes de presupuesto enviadas a {{count}} contratistas",
    notToldTitle: "Asignado, pero sin avisar",
    notToldBody: "{{name}} tiene el trabajo pero no tiene correo ni cuenta, así que nadie le avisó. Avísale tú.",
    failedTitle: "No se pudo crear el trabajo",
    failedBody: "Inténtalo de nuevo.",
  },
  scope: { contractorWork: "Trabajo como contratista" },
  reportsTab: { all: "Todos los informes", versionsTitle: "Versiones de {{kind}}", openReport: "Abrir {{kind}}", noVersions: "Todavía no hay versiones guardadas.", more: "{{n}} más en {{kind}}", withSubJobs: "Trabajos con subtrabajos" },
queueRow: {
secondaryDefault: "Iniciar",
you: "Tú",
raisedBy: "Creado por {{name}}",
planned: "Planificado {{when}}",
unassigned: "Sin asignar",
showFewerStatusLabels: "Mostrar menos etiquetas de estado",
showMoreStatusLabels_one: "Mostrar {{count}} etiqueta de estado más: {{labels}}",
showMoreStatusLabels_other: "Mostrar {{count}} etiquetas de estado más: {{labels}}",
moreActionsForA11y: "Otras acciones para {{title}}",
secondaryActionA11y: "{{action}} {{title}}",
openItemA11y: "Abrir {{title}}",
open: "Abrir",
showMoreStatusLabels_many: "Mostrar {{count}} etiquetas de estado más: {{labels}}",
},
jobChecks: {
  inline: {
    hide: "Ocultar respuestas",
    loading: "Cargando las respuestas…",
    loadFailed: "No se han podido cargar las respuestas. Vuelve a abrir el trabajo para reintentar.",
    failed: "No superado",
    skipped: "Omitido",
    photos_one: "{{count}} foto",
    photos_many: "{{count}} fotos",
    photos_other: "{{count}} fotos",
  },
stageLabel: {
pre: "Revisión previa",
post: "Revisión posterior",
standalone: "Revisión",
},
stageLabelLower: {
pre: "revisión previa",
post: "revisión posterior",
standalone: "revisión",
},
round: "Ronda {{n}}",
noneYet: "Ninguna todavía",
removeStageA11y: "Quitar {{stage}}",
attachFailedTitle: "Trabajo creado, pero no se pudo adjuntar la {{stage}}",
attachFailedBody: "Añádala desde el trabajo.",
attach: {
addAs: "Añadir como {{stage}}",
chooseChecklist: "Elija una lista de verificación",
attachTemplateAsA11y: "Adjuntar {{name}} como {{stage}}",
chooseFirstA11y: "Elija primero una lista de verificación",
attachAsA11y: "Adjuntar como {{stage}}",
loadingTitle: "Cargando sus listas de verificación…",
loadingBody: "Un momento: obteniendo la biblioteca.",
noMatchTitle: "Ninguna lista de verificación coincide",
noMatchBody: "Pruebe una búsqueda más corta o bórrela para verlo todo.",
emptyTitle: "Aún no hay listas de verificación para adjuntar",
emptyBody: "Cualquier lista de verificación puede usarse como revisión. Cree una y aparecerá aquí.",
},
resultLabel: {
pass: "Aprobado",
flag: "Marcado",
fail: "Fallido",
},
stepCount_one: "{{completed}}/{{count}} paso",
stepCount_other: "{{completed}}/{{count}} pasos",
gateReasonSingle: "La {{stage}} “{{name}}” debe completarse {{verb}}.",
gateReasonMultiple: "{{count}} {{noun}} deben completarse {{verb}}.",
checksNoun: "revisiones",
beforeSubmitted: "antes de enviar esta orden de trabajo",
beforeStarted: "antes de que comience esta orden de trabajo",
gateDefaultReason: "Primero debe completarse una revisión.",
templateStepCount_one: "{{count}} paso",
templateStepCount_other: "{{count}} pasos",
historyOneFailure: "1 fallo en {{span}}.",
historyFailures_one: "{{count}} fallo en {{span}}.",
historyFailures_many: "{{count}} fallos en {{span}}.",
historyFailures_other: "{{count}} fallos en {{span}}.",
historyOneFlag: "1 elemento marcado en {{span}}.",
historyFlags_one: "{{count}} elemento marcado en {{span}}.",
historyFlags_many: "{{count}} elementos marcados en {{span}}.",
historyFlags_other: "{{count}} elementos marcados en {{span}}.",
historyNoFailures: "No hay fallos en {{span}}.",
spanLastCheck: "la última revisión",
spanLastChecks_one: "la última revisión",
spanLastChecks_many: "las últimas {{count}} revisiones",
spanLastChecks_other: "las últimas {{count}} revisiones",
completedStatus: "Completado {{progress}}",
notFinishedStatus: "{{progress}} — no terminado",
reworkRequested: "Repetición solicitada",
section: {
heading: "Qué necesita este trabajo",
addCheckA11y: "Añadir una revisión a esta orden de trabajo",
addCheck: "Añadir revisión",
tryAgainA11y: "Volver a cargar las revisiones",
tryAgain: "Intentar de nuevo",
noChecksTitle: "No hay controles en esta orden de trabajo",
headingPlan: "Qué necesita cada trabajo",
noChecksTitlePlan: "Aún no hay revisiones",
noChecksBody: "Adjunte una lista de verificación para ejecutar antes de que comience el trabajo o después de que finalice, y sus respuestas se convertirán en la evidencia de que se realizó esta orden de trabajo.",
required: "Obligatorio",
round: "Ronda {{number}}",
stop: "Parada {{number}}: {{name}}",
checkFallback: "Revisión",
openCheckA11y: "{{verb}} {{stage}} {{name}}. {{progress}}.",
review: "Revisar",
continueVerb: "Continuar",
start: "Iniciar",
reviewCheck: "Repasar la revisión",
continueCheck: "Continuar revisión",
startCheck: "Iniciar verificación",
removeCheckA11y: "Quitar {{stage}} {{name}}",
remove: "Quitar",
},
stepCount_many: "{{completed}}/{{count}} pasos",
templateStepCount_many: "{{count}} pasos",
},
requestActivityStream: {
  tidyFailedBody: "Inténtalo en un momento o envíalo tal cual.",
  tidyFailedTitle: "No se pudo mejorar el mensaje",
  tidiedReview: "Revísalo antes de enviarlo.",
  tidiedTitle: "Mensaje mejorado",
  tidyUp: "Mejorar con IA",
  stop: "Detener",
  noAccountHint: "{{name}} no tiene cuenta y no verá los mensajes aquí. Usa Hacer una pregunta para escribirle por correo.",
  notSent: "No enviado. Comprueba tu conexión y pulsa Enviar de nuevo.",
theRequesterDefault: "El solicitante",
theTeamDefault: "El equipo",
raisedThis: "{{who}} planteó esto · {{time}}",
you: "Tú",
noMessagesYetOperator: "Aún no hay mensajes; responda a continuación para iniciar la conversación.",
noMessagesYetRequester: "Aún no hay mensajes; envíe uno a continuación y el equipo responderá aquí.",
removePhotoA11y: "Eliminar foto",
replyOrLogNoteA11y: "Escribir al solicitante",
messageTeamA11y: "Envía un mensaje al equipo",
replyOrLogNotePlaceholder: "Mensaje al solicitante (lo ve)…",
messageTeamPlaceholder: "Envía un mensaje al equipo...",
sending: "Enviando…",
send: "Enviar",
sendReplyA11y: "Enviar respuesta",
signInRequiredTitle: "Inicio de sesión necesario",
signInToAttachPhotos: "Inicia sesión para adjuntar fotos.",
uploadFailedTitle: "Error al cargar",
couldNotAttachPhoto: "No se pudo adjuntar la foto.",
},
requestDetailHeader: {
noPriority: "Sin prioridad",
assetNotSet: "Activo no establecido",
notSet: "Sin definir",
tileLabel: {
asset: "Activo",
requester: "Solicitante",
priority: "Prioridad",
scheduled: "Programado",
respondBy: "Responder antes de",
},
openTileA11y: "Abrir {{label}}: {{value}}",
escalated: "Escalado · 48h+",
nextPrefix: "Siguiente: ",
},
repairDecisionPanel: {
yourDecisions: "Tus decisiones",
progress: "{{decided}} de {{total}} decididos",
approveRecommendationTitle: "¿De acuerdo con todos los elementos?",
approveRecommendationHint: "Marca todos los elementos como aprobados. Aún puedes rechazar alguno antes de firmar.",
applying: "Aplicando...",
approveRecommended: "Aprobar todo",
urgent: "Urgente",
highPriority: "Alta prioridad",
noEvidence: "Sin evidencia",
possibleDuplicate: "Posible duplicado",
approved: "Aprobado",
declined: "Rechazado",
awaitingDecision: "Esperando decisión",
approve: "Aprobar",
decline: "Rechazar",
approveItemA11y: "Aprobar {{label}}",
declineItemA11y: "Rechazar {{label}}",
seeEvidenceA11y: "Ver la evidencia de {{label}}",
openAllEvidenceA11y: "Abrir todas las pruebas de {{label}}",
evidenceThumbA11y: "{{label}} evidencia {{number}}",
declineNoteA11y: "Nota de rechazo para {{label}}",
declineNotePlaceholder: "¿Por qué estás rechazando? (opcional – compartido con el equipo)",
photoCount_one: "{{count}} foto",
photoCount_other: "{{count}} fotos",
videoCountClause_one: " · {{count}} vídeo",
videoCountClause_other: " · {{count}} vídeos",
viewDetailsClause: " · Ver detalles",
approvedTotal: "Total aprobado: {{amount}}",
nothingApprovedYet: "Aún no hay nada aprobado.",
photoCount_many: "{{count}} fotos",
videoCountClause_many: " · {{count}} vídeos",
},
workIntelligenceActions: {
analyzeEvidence: "Leer las fotos",
useComment: "Usar comentario",
draftComment: "Redactar comentario",
suggestAction: "Sugerir acción",
useSuggestion: "Usar sugerencia",
createJobFromSuggestion: "Crear orden de trabajo a partir de sugerencia",
createJob: "Crear orden de trabajo",
assessEvidence: "Evaluar evidencia",
useNote: "Usar nota",
couldNotCompleteRequest: "No se pudo completar la solicitud.",
unexpectedError: "Error inesperado",
aiSuggestionWithConfidence: "Sugerencia de IA · {{percent}}% de confianza",
aiSuggestion: "Sugerencia de IA",
priorityLabel: "Prioridad: {{priority}}",
riskLabel: "Riesgo: {{band}} ({{score}}/100)",
dismissSuggestionA11y: "Descartar sugerencia",
dismiss: "Descartar",
},
reportAccessRequests: {
roleLabel: {
owner: "Propietario",
tenant: "Inquilino/ocupante",
landlord: "Arrendador",
manager: "Agente administrador",
client: "Cliente",
contractor: "Contratista",
other: "Otro",
},
headerCount_one: "Solicitud de acceso a informes · {{count}}",
headerCount_other: "Solicitudes de acceso a informes · {{count}}",
someoneFallback: "Alguien",
assetFallback: "Activo",
approve: "Aprobar",
decline: "Rechazar",
couldNotCompleteTitle: "No se pudo completar",
tryAgainMoment: "Vuelva a intentarlo en un momento.",
alreadyDecidedTitle: "Ya decidido",
alreadyDecidedMessage: "Alguien más ya respondió a esta solicitud.",
notPermittedTitle: "No permitido",
notPermittedMessage: "No tiene permiso para decidir esta solicitud.",
accessApproved: "Acceso al informe aprobado",
requestDeclined: "Solicitud rechazada",
headerCount_many: "Solicitudes de acceso a informes · {{count}}",
},
assetRequestDetailScreen: {
actions: {
openJob: "Abrir orden de trabajo",
openInspection: "Abrir inspección",
approve: "Aprobar",
replyFirstTitle: "¿Marcar como respondido y continuar?",
replyFirstBody: "Este caso espera al cliente. Al continuar se registra su respuesta y se sigue adelante.",
replyFirstCancel: "Ahora no",
replyFirstConfirm: "Marcar como respondido",
decline: "Rechazar",
replied: "Registrar su respuesta",
ask: "Hacer una pregunta",
inspect: "Inspeccionar",
createWork: "Crear trabajo",
close: "Cerrar solicitud",
},
assistant: {
title: "Asistente",
turnIntoWork: "Convertir en trabajo",
suggestNextSteps: "Sugerir próximos pasos",
requestAssistantTitle: "Asistente de la solicitud",
promptWithTitle: "Ayúdame a revisar esta solicitud (“{{title}}”) y decidir si preguntar, inspeccionar, crear trabajo o cerrarla.",
promptDefault: "Ayúdame a revisar esta solicitud y decidir si preguntar, inspeccionar, crear trabajo o cerrarla.",
},
capture: {
notSavedTitle: "Captura no guardada",
notFoundMessage: "No se pudo encontrar esa captura. Vuelve a capturarla.",
mismatchMessage: "Esta captura no coincide con la solicitud actual.",
notSupportedTitle: "Captura no compatible",
scanNotSupportedMessage: "El escaneo QR se gestiona desde el escáner y no se guarda en las solicitudes.",
tryAgain: "Comprueba tu conexión e inténtalo de nuevo.",
noPhotoCaptured: "No se capturó ninguna foto.",
signInToAttachPhotos: "Inicia sesión para adjuntar fotos.",
couldNotUploadPhoto: "No se pudo cargar la foto.",
noCommentTextCaptured: "No se capturó ningún texto de comentario.",
modeNotSupported: "Este modo de captura no es compatible con solicitudes.",
photoAdded: "Foto agregada a la solicitud",
commentAdded: "Comentario añadido a la solicitud",
measurementAdded: "Medición añadida a los comentarios de la solicitud",
measurementCommentTemplate: "Medición: {{reading}}",
},
toast: {
approved: "Solicitud aprobada y solicitante avisado. Ahora toca Crear trabajo o Inspeccionar para planificarla.",
declined: "Solicitud rechazada. Se ha avisado al solicitante.",
caseClosed: "Solicitud cerrada. Se ha avisado al solicitante.",
replyRecorded: "Respuesta registrada. La solicitud vuelve a ti para continuar.",
messageSent: "Pregunta enviada. La solicitud espera su respuesta y se te avisará cuando contesten.",
caseReopened: "Solicitud reabierta. Vuelve a estar en Trabajo, en Requiere su atención.",
},
screenTitle: "Solicitud",
loadingMessage: "Cargando solicitud...",
notFoundMessage: "Solicitud no encontrada",
notFoundHint: "Es posible que esta solicitud se haya eliminado o que no tenga acceso.",
requestFallbackTitle: "Solicitud",
reopenFailedTitle: "No se pudo reabrir la solicitud",
},
requestCaseLinkedWork: {
statusLabel: {
scheduled: "Programado",
toSchedule: "Por programar",
due: "Vence",
overdue: "Vencido",
inProgress: "En curso",
paused: "Pausada",
submitted: "Enviada",
completedAwaitingSignoff: "Completado: pendiente de aprobación",
done: "Hecho",
reworkInProgress: "Retrabajo en progreso",
cancelled: "Cancelado",
pending: "Pendiente",
},
reportStatus: {
sharedReadyForReview: "Compartido: listo para revisión",
approved: "Aprobado",
changesRequested: "Cambios solicitados",
reviewed: "Revisado",
},
provenance: {
youApproved: "Aprobaste este trabajo.",
approvedByRequester: "Aprobado por el solicitante",
youDeclined: "Rechazaste esto; menciónalo en la conversación.",
declinedByRequester: "Rechazado por el solicitante",
followUpProposed: "Seguimiento propuesto por el equipo.",
followUpJob: "Orden de trabajo de seguimiento",
addedByTeamNotFromReview: "Agregado por el equipo, no de su revisión",
addedByTeam: "Añadido por el equipo",
},
repair: {
fallbackLabel: "Reparación {{number}}",
approved: "Aprobado",
declined: "Rechazado",
awaitingDecision: "Esperando decisión",
jobState: "Orden de trabajo: {{status}}",
noJobYet: "Aún no hay orden de trabajo",
},
heading: "Trabajo vinculado",
inspectionTitle: "Inspección",
completed: "Completado",
jobFallbackTitle: "Orden de trabajo",
reportTitle: "Informe de inspección",
youAcceptedAwaitingTeam: "Aceptaste, esperando la confirmación del equipo.",
acceptedByRequesterVerify: "Aceptado por el solicitante: verificar para cerrar",
visitConfirmed: "Visita confirmada",
visitConfirmedByRequester: "Visita confirmada por el solicitante",
confirmVisitBelow: "Confirma la visita a continuación",
awaitingRequesterVisitConfirmation: "En espera de confirmación de la visita del solicitante",
photoCount_one: "{{count}} foto",
photoCount_other: "{{count}} fotos",
approvedRepairsAwaitingJobs_one: "{{count}} reparación aprobada en espera de órdenes de trabajo",
approvedRepairsAwaitingJobs_other: "{{count}} reparaciones aprobadas en espera de órdenes de trabajo",
createApprovedJobs_one: "Crear {{count}} orden de trabajo aprobada",
createApprovedJobs_other: "Crear {{count}} órdenes de trabajo aprobadas",
confirmVisit: "Confirmar visita",
confirmVisitA11y: "Confirma que alguien puede estar allí para la visita.",
requestDifferentTime: "Solicitar hora diferente",
requestDifferentTimeA11y: "Solicitar otro horario de visita",
reviewCompletionReport: "Revisar el informe de finalización",
reviewAndSignOff: "Revisar y dar conformidad",
viewCompletionReport: "Ver informe de finalización",
openCompletionReportA11y: "Abrir el informe de finalización de la orden de trabajo",
acceptCompletion: "Aceptar el trabajo",
acceptCompletionA11y: "Aceptar el trabajo completado.",
requestRework: "Devolver",
requestReworkA11y: "Devolver el trabajo para que lo corrijan",
createJobsFromRepairsA11y: "Crear órdenes de trabajo a partir de las reparaciones aprobadas.",
viewReportResponse: "Ver respuesta del informe",
reviewSharedReport: "Revisar informe compartido",
viewYourReportResponseA11y: "Ver la respuesta de su informe",
reviewSharedReportA11y: "Revisar el informe compartido",
photoCount_many: "{{count}} fotos",
approvedRepairsAwaitingJobs_many: "{{count}} reparaciones aprobadas en espera de órdenes de trabajo",
createApprovedJobs_many: "Crear {{count}} órdenes de trabajo aprobadas",
},
detailRoute: {
notFoundTitle: "Detalle de trabajo",
notFoundMessage: "Elemento de trabajo no encontrado",
notFoundHint: "Abra esta orden de trabajo o inspección desde Trabajo, Activos o un enlace compartido válido.",
},
kanbanSwimlanes: {
emptyDefault: "No hay elementos en esta vista.",
unassigned: "Sin asignar",
assetColumnHeader: "Activo",
},
queueCardGrid: {
emptyDefault: "No hay elementos en la cola",
open: "Abrir",
start: "Iniciar",
openItemA11y: "Abrir {{title}}",
startItemA11y: "Iniciar {{title}}",
},
statusTransitionBar: {
currentA11y: "Estado: {{label}}",
moveToA11y: "Mover a {{label}}",
changeStatusA11y: 'Estado: {{label}}. Cambiar estado',
sheetTitle: 'Cambiar estado',
},
stall: {
days_one: "{{count}} día",
days_many: "{{count}} de días",
days_other: "{{count}} días",
waitingOnYourApproval: "Esperando su aprobación desde hace {{span}}.",
waitingOnYourValidation: "Esperando su validación desde hace {{span}}.",
noResponseFrom: "Sin respuesta de {{name}} desde hace {{span}}.",
notValidated: "{{name}} no ha validado esto desde hace {{span}}.",
notApproved: "{{name}} no ha aprobado esto desde hace {{span}}.",
theRecipient: "el destinatario",
theRequester: "el solicitante",
theApprover: "El aprobador",
theValidator: "El validador",
approveOnTheirBehalf: "Aprobar en su nombre",
validateInTheirPlace: "Validar en su lugar",
hintDecide: "Como equipo del activo, puede decidir por ellos. Ambas opciones se registran como hechas en su nombre.",
hintValidate: "Como equipo del activo, puede validar esto en su lugar.",
hintSignOff: "Como equipo del activo, puede aprobar esto en su lugar.",
saving: "Guardando…",
},
triageInbox: {
titleDefault: "Nuevas",
emptyLabelDefault: "No hay solicitudes nuevas.",
cleared: "Todas las solicitudes decididas",
approve: "Aprobar",
reject: "Rechazar",
},
nameTypeFilter: {
typeDefault: "Tipo",
pickerTitleDefault: "Filtrar por tipo",
any: "cualquiera",
typeA11y: "{{label}}: {{value}}",
},
sortMenu: {
triggerA11y: "Ordenar: {{label}}",
sortBy: "Ordenar por",
},
viewToggle: {
cards: "Tarjetas",
table: "Tabla",
kanban: "Kanban",
calendar: "Calendario",
},
attentionReasons: {
OVERDUE: "Vencido",
AWAITING_YOU: "Pendiente de usted",
AWAITING_OTHER: "Pendiente de otra persona",
UNSCHEDULED: "Aún sin programar",
DUE_SOON: "Vence pronto",
URGENT_PRIORITY: "Marcado como urgente",
APPROVAL_REQUIRED: "Pendiente de su aprobación",
REVIEW_REQUIRED: "Pendiente de su revisión",
REPAIR_JOBS_REQUIRED: "Las reparaciones aprobadas necesitan órdenes de trabajo",
STALLED: "Sin respuesta — puede intervenir",
},
list: {
  board: {
    moveItemA11y: "Mover {{title}}",
    moveSelectedA11y: "Mover {{n}} a {{column}}",
    bulkSummaryBlocked: "Mover {{n}} a {{column}}. {{blocked}} no se pueden mover desde su estado actual.",
    bulkSummary: "Mover {{n}} a {{column}}.",
    requestMoveReason: "Las solicitudes avanzan al aprobarlas, rechazarlas o convertirlas: ábrala para decidir.",
    inspectionMoveReason: "Las inspecciones avanzan al realizarlas: ábrala para continuar.",
    moveNotAllowedTitle: "Movimiento no permitido",
    moveNotAllowed: "Ese movimiento no está permitido.",
    cannotMoveStraight: "Un trabajo «{{from}}» no puede pasar directamente a «{{to}}».",
  },
  selectedA11y: "Seleccionado",
  emptyState: {
    showMeHow: "Muéstrame cómo",
    scheduleInspection: "Programar una inspección",
    none: "Todavía no hay trabajo aquí. Programe una inspección para empezar.",
    showAll: "Mostrar todo el trabajo",
    review: "Nada está pendiente de revisión.",
    due_soon: "Nada vence pronto.",
    mine: "No tiene nada asignado en este momento.",
    needs_attention: "Nada requiere su atención en este momento.",
    clearFilters: "Borrar filtros",
    filtered: "Nada coincide con lo que eligió en Refinar.",
  },
simpleStatus: {
  todo: "Pendiente",
  in_progress: "En curso",
  waiting: "En espera",
  done: "Hecho",
  waitingFor: "Esperando a {{name}}",
  waitingOn: "En espera · {{who}}",
  waitingForAssignee: "Esperando al asignado",
  waitingForRequester: "Esperando al solicitante",
  waitingForReview: "Esperando revisión",
  waitingForQuotes: "Esperando presupuestos",
  waitingForApproval: "Esperando aprobación",
},
quickView: {
needs_attention: "Requiere su atención",
mine: "Mío",
due_soon: "Vence pronto",
review: "Revisión",
all: "Todo",
},
reviewScope: {
  yours: "Las suyas",
  everyone: "De todos",
},
view: {
  calendarShort: "Calendario",
  listShort: "Lista",
  title: "Vista",
cards: "Vista de lista",
calendar: "Vista de calendario",
},
type: {
request: "Solicitudes",
inspection: "Inspecciones",
job: "Órdenes de trabajo",
},
sort: {
urgency: "Urgencia",
due: "Fecha de vencimiento",
updated: "Actualizado recientemente",
priority: "Prioridad",
created: "Más reciente",
},
group: {
asset: "Activo",
site: "Sitio",
assignee: "Responsable",
status: "Estado",
type: "Tipo",
none: "Ninguno",
},
groupUrgent_one: "{{count}} urgente",
groupUrgent_many: "{{count}} urgentes",
groupUrgent_other: "{{count}} urgentes",
groupByLabel: "Agrupar: {{axis}}",
groupByTitle: "Agrupar el trabajo por",
collapseAll: "Contraer todo",
expandAll: "Expandir todo",
collapseGroup: "Contraer {{name}} ({{count}})",
expandGroup: "Expandir {{name}} ({{count}})",
groupOverdue: "Vencido: {{count}}",
groupNeedsYou: "Para usted: {{count}}",
groupDueSoon: "Vence pronto: {{count}}",
groupNew: "Nuevo: {{count}}",
groupTypeDocument: "Documentos",
groupNone: { asset: "Sin activo", site: "Sin sitio", assignee: "Sin asignar" },
newLane: { title: "Nuevo desde tu última visita", more: "Mostrar {{count}} más", fewer: "Mostrar menos" },
openAsset: "Abrir {{name}}",
report: {
all: "Cualquiera",
has_report: "Con informe",
awaiting_review: "Pendiente de revisión",
signed_off: "Aprobado",
},
refine: {
button: "Refinar",
output: "Resultado",
type: "Tipo",
asset: "Activo",
site: "Sitio",
assignee: "Responsable",
unassigned: "Sin asignar",
urgency: "Urgencia",
status: "Estado",
review: "Revisión",
reviewToggle: "Requiere mi revisión",
time: "Periodo",
renewals: "Renovaciones",
renewalsToggle: "Mostrar renovaciones",
sortBy: "Ordenar por",
anyAsset: "Cualquier activo",
unnamedSite: "Sitio sin nombre",
unnamedAssignee: "Persona sin nombre",
anySite: "Cualquier sitio",
anyone: "Cualquiera",
assigneeFacetTeam: "Equipo",
assigneeFacetExternal: "Externo",
selectedCount_one: "{{count}} seleccionado",
selectedCount_many: "{{count}} seleccionados",
selectedCount_other: "{{count}} seleccionados",
searchPlaceholder: "Buscar…",
searchAssetPlaceholder: "Buscar activos…",
removeAsset: "Quitar {{name}}",
searchSitePlaceholder: "Buscar sitios…",
searchAssigneePlaceholder: "Buscar personas…",
noMatches: "Sin resultados.",
clear: "Borrar",
clearSelection: "Borrar selección",
done: "Listo",
},
timePreset: {
overdue: "Vencido",
today: "Hoy",
next_7: "Próximos 7 días",
},
urgencyBand: {
critical: "Crítica",
high: "Alta",
medium: "Media",
low: "Baja",
},
status: {
triage: "Nuevas",
scheduled: "Programado",
in_progress: "En curso",
awaiting_review: "Pendiente de revisión",
done: "Finalizado",
cancelled: "Cancelado",
},
kanbanEmpty: {
triage: "No hay solicitudes nuevas.",
scheduled: "No hay nada programado.",
in_progress: "No hay nada en curso.",
awaiting_review: "No hay nada pendiente de revisión.",
done: "Aún no se ha finalizado nada.",
cancelled: "No hay nada cancelado.",
board: "No hay trabajo en curso en esta vista.",
},
due: {
  inDays: "Vence en {{n}} d",
  overdueDays: "{{n}} d de retraso",
overdue: "Vencido",
today: "Vence hoy",
tomorrow: "Vence mañana",
onDate: "Vence el {{date}}",
},
badge: {
urgency: {
critical: "Urgente",
high: "Alta",
},
rework: "Devuelto",
quotesDeclined: "Todos rechazados",
quotesWaiting: "Esperando presupuestos",
awaitingRequester: "Esperando al solicitante",
subJobsDone: "{{done}} de {{total}} subtrabajos hechos",
subJobNeedsYou: "Un subtrabajo te necesita",
partOf: "Parte de {{title}}",
partOfAJob: "Parte de un trabajo mayor",
confirmVisit: "Confirmar la visita",
visitUnconfirmed: "Visita sin confirmar",
acceptancePending: "Aceptar o rechazar",
awaitingAcceptance: "Esperando aceptación",
awaitingVerification: "Esperando verificación",
quoteInvited: "Invitación a presupuestar",
attention: {
overdue: "Vencido",
awaiting_you: "En espera de usted",
stalled: "Estancado",
unscheduled: "Sin programar",
expiring_soon: "Vence pronto",
},
column: {
triage: "Abierto",
scheduled: "Programado",
in_progress: "En curso",
awaiting_review: "Pendiente de revisión",
},
review: {
awaiting_your_approval: "Aprobar",
you_must_review: "Revisar",
awaiting_recipient: "Esperando respuesta",
changes_requested: "Cambios solicitados",
},
report: {
awaiting_repairs_conversion: "Reparaciones aprobadas",
pending_signoff: "Informe listo",
signed_off: "Aprobado",
},
done: {
completed: "Cerrado",
verified: "Aprobado",
rejected: "Rechazado",
cancelled: "Cancelado",
superseded: "Sustituido",
skipped: "Omitido",
},
},
empty: "No hay nada aquí por ahora.",
emptyReports: "Aún no hay informes. Un informe aparece aquí cuando una inspección o un trabajo lo tiene.",
previewEmpty: "Seleccione una orden de trabajo o una solicitud para gestionarla aquí.",
loadError: "No se ha podido cargar parte del trabajo ({{sources}}).",
retry: "Reintentar",
loadingA11y: "Cargando trabajo",
preview: {
kind: {
job: "Orden de trabajo",
request: "Solicitud",
inspection: "Inspección",
schedule: "Inspección",
document: "Documento",
},
asset: "Activo",
status: "Estado",
due: "Vence",
noDue: "Sin fecha de vencimiento",
assigned: "Asignado",
unassigned: "Sin asignar",
site: "Sitio",
report: "Informe",
reportAvailable: "Disponible",
reportNone: "No disponible",
openFull: "Abrir registro completo",
openFullKind: "Abrir {{kind}}",
pin: "Fijar panel",
unpin: "Dejar de fijar panel",
collapse: "Contraer panel",
},
},
aiNextSteps: {
summaryReady: "{{ready}} de {{total}} listos para ejecutar",
createdMore: "+{{count}} más",
openCreatedA11y: "Abrir {{label}}",
recordKind: {
job: "Ver orden de trabajo",
inspection_schedule: "Ver inspección programada",
request: "Ver solicitud",
template: "Ver lista de control",
},
title: "Próximos pasos sugeridos",
planning: "Calculando los mejores próximos pasos…",
running: "Ejecutando los pasos confirmados…",
empty: "Ahora mismo no hay nada que hacer aquí.",
doAll: "Hacer todo ({{total}})",
doStep: "Hacer esto",
doStepA11y: "Ejecutar este paso: {{step}}",
retry: "Reintentar",
dismiss: "Descartar",
errorFallback: "No se pudieron sugerir próximos pasos.",
blocked: {
advisory: "Solo orientación: no hay nada que ejecutar automáticamente.",
missingDetails: "Faltan algunos datos antes de poder ejecutarlo.",
},
outcome: {
executed: "Hecho",
failed: "Este paso no se completó.",
},
results: {
allDone: "Todos los pasos confirmados se completaron ({{total}}).",
partial: "{{executed}} completados, {{failed}} con errores.",
},
confirm: {
title: "Confirma lo que va a pasar",
intro: "Esto se ejecutará ahora y cambiará tus registros ({{total}}):",
noDetail: "No hay más detalles disponibles.",
run: "Ejecutar ahora",
cancel: "Cancelar",
},
},
workflow: {
actions: {
requestedReview: "Revisión solicitada",
approvedRepairs: "Reparaciones aprobadas",
assignedWork: "Trabajo asignado",
scheduleProposed: "Programación propuesta",
workStarted: "Trabajo iniciado",
workPaused: "Trabajo en pausa",
workResumed: "Trabajo reanudado",
completionSubmitted: "Finalización enviada",
reworkRequested: "Repetición solicitada",
workApproved: "Trabajo aprobado",
jobAccepted: "Orden de trabajo aceptada",
jobDeclined: "Orden de trabajo rechazada",
quoteRequestSent: "Solicitud de presupuesto enviada",
quoteSubmitted: "Presupuesto enviado",
quoteAccepted: "Presupuesto aceptado",
quoteRejected: "Presupuesto rechazado",
contractorAwarded: "Contratista adjudicado",
},
},
search: {
title: "Buscar en Trabajo",
placeholder: "Buscar inspecciones, órdenes de trabajo, solicitudes o activos",
triggerA11y: "Buscar en Trabajo",
triggerHint: "Buscar inspecciones, órdenes de trabajo, solicitudes o activos",
inputA11y: "Buscar inspecciones, órdenes de trabajo, solicitudes o activos",
closeA11y: "Cerrar búsqueda de Trabajo",
clearA11y: "Borrar búsqueda de Trabajo",
scope: {
all: "Todo",
inspections: "Inspecciones",
jobs: "Órdenes de trabajo",
requests: "Solicitudes",
},
scopeActive: "Solo {{type}} ✕",
groups: {
inspection: "Inspecciones",
job: "Órdenes de trabajo",
request: "Solicitudes",
asset: "Activos",
contact: "Contactos",
},
refine: "Refinar",
refineCount: "Refinar {{count}}",
refineA11y_one: "Refinar la búsqueda de Trabajo, {{count}} categoría de filtro activa",
refineA11y_many: "Refinar la búsqueda de Trabajo, {{count}} categorías de filtro activas",
refineA11y_other: "Refinar la búsqueda de Trabajo, {{count}} categorías de filtro activas",
clearFilters: "Borrar todo",
filters: {
state: "Estado",
scope: "Ámbito",
all: "Todo",
open: "Abierto",
completed: "Completado",
mine: "Asignado a mí",
team: "Mi equipo",
needsAttention: "Requiere atención",
},
minimumTitle: "Buscar en todo Trabajo",
recentsTitle: "Recientes",
recentsClear: "Borrar",
pinA11y: "Fijar para mantener arriba",
unpinA11y: "Dejar de fijar",
minimumBody: "Introduzca al menos dos caracteres para buscar en las inspecciones, órdenes de trabajo, solicitudes y activos autorizados.",
loading: "Buscando en Trabajo…",
errorTitle: "La búsqueda no está disponible",
errorBody: "No se ha podido buscar en Trabajo. Compruebe su conexión e inténtelo de nuevo.",
noResultsTitle: "Sin trabajo coincidente",
noResultsBody: "Pruebe con otro título, referencia, activo, ubicación o responsable.",
viewAll: "Ver todo",
viewAllA11y: "Ver todos los resultados de {{type}}",
result: {
type: {
inspection: "Inspección",
job: "Orden de trabajo",
request: "Solicitud",
asset: "Activo",
contact: "Contacto",
},
statusA11y: "Estado {{status}}",
dateA11y: "Fecha {{date}}",
assigneeA11y: "Asignado a {{name}}",
},
},
hub: {
title: "Trabajo",
impactTitle: "Solo algunos activos",
impactBody_one: "Esta lista solo muestra el trabajo de {{count}} activo.",
impactBody_other: "Esta lista solo muestra el trabajo de {{count}} activos.",
impactClear: "Mostrar todo",
impactClearA11y: "Mostrar el trabajo de todos los activos",
tablistLabel: "Filtrar Trabajo por tipo: Inspecciones, Órdenes de trabajo o Solicitudes",
emptyViewAll: "Ver todo",
segments: {
queue: "Mi cola",
inspections: "Inspecciones",
jobs: "Órdenes de trabajo",
approvals: "Aprobaciones",
requests: "Solicitudes",
templates: "Listas de control de inspección",
},
hints: {
queue: "Mostrar trabajo priorizado (inspecciones, trabajos y elementos pendientes de decisión)",
inspections: "Mostrar inspecciones, revisiones y programaciones",
jobs: "Órdenes de trabajo y carga de trabajo",
approvals: "Revisa las solicitudes entrantes y el trabajo completado pendiente de una decisión.",
requests: "Clasifica las solicitudes entrantes; apruébalas, prográmalas o conviértelas en inspecciones u órdenes de trabajo.",
templates: "Listas de verificación de inspección reutilizables",
inspectionsFilter: "Muestra en Trabajo solo inspecciones, revisiones y programaciones. Vuelve a seleccionarlo para ver todo lo que requiere tu atención.",
jobsFilter: "Muestra en Trabajo solo órdenes de trabajo. Vuelve a seleccionarlo para ver todo lo que requiere tu atención.",
requestsFilter: "Muestra en Trabajo solo solicitudes entrantes. Vuelve a seleccionarlo para ver todo lo que requiere tu atención.",
},
secondaryLabel: "Secundario",
workflowLibrary: "Listas de control",
workflowLibraryShort: "Listas de control",
workflowLibraryHint: "Listas de verificación de inspección reutilizables",
workflowLibraryA11y: "Abrir listas de control",
workflowLibraryBack: "Volver a Trabajo",
workflowLibraryBackHint: "Salir de las listas de control",
workflowLibraryBackA11y: "Volver a la cola de trabajo",
secondaryToolsTitle: "Informes operativos",
secondaryToolsSummary: "Informes y análisis.",
secondaryToolsMeta: "1 herramienta secundaria",
status: {
attention: "Requiere atención",
inspections: "Inspecciones abiertas",
jobs: "Órdenes de trabajo abiertas",
approvals: "Aprobaciones",
requests: "Solicitudes",
},
nextAction: {
eyebrow: "Siguiente paso recomendado",
reviewApprovals: "Revisar aprobaciones",
reviewApprovalsMeta: "Decida qué solicitudes entrantes y trabajo completado avanzan a continuación.",
openQueue: "Mostrar todo lo que requiere su atención",
openQueueMeta: "Vencido, que vence hoy y bloqueado.",
continueInspections: "Continuar inspecciones",
continueInspectionsMeta: "Planificadas, activas y completadas.",
continueJobs: "Continuar órdenes de trabajo",
continueJobsMeta: "Responsables, bloqueos, fechas, estado.",
backToQueue: "Volver a Trabajo",
backToQueueMeta: "Volver a todo lo que requiere su atención.",
openWorkflows: "Abrir listas de control",
openWorkflowsMeta: "Cree o reutilice listas de verificación de inspección.",
},
impactBody_many: "Esta lista solo muestra el trabajo de {{count}} activos.",
},
queue: {
mobileFilter: {
all: "Todo",
overdue: "Vencido",
today: "Hoy",
approvals: "Aprobaciones",
a11y: "Filtrar cola: {{label}}",
},
focus: {
showing: "Mostrando {{label}} · {{count}}",
inProgress: "Trabajo en curso",
attention: "Requiere tu atención",
clear: "Quitar",
clearA11y: "Quitar el filtro y mostrar toda la cola",
showAll: "Mostrar todo",
},
emptyFocused: "Nada aquí: {{label}}.",
refineGroupBy: "AGRUPAR POR",
groupBy: {
asset: "Por activo",
status: "Por estado",
},
table: {
type: "Tipo",
},
calendar: {
today: "Hoy",
todayA11y: "Ir a hoy",
prevMonthA11y: "Mes anterior",
nextMonthA11y: "Mes siguiente",
moreCount: "+{{count}} más",
emptyDay: "Nada previsto este día",
dayA11y: "{{date}} — {{count}} previsto(s): {{summary}}",
dayEmptyA11y: "{{date}} — nada previsto",
summaryAndMore: "{{titles}} y {{count}} más",
openItemA11y: "Abrir {{type}}: {{title}}",
unscheduledTitle: "Sin programar · {{count}}",
unscheduledHint: "Todavía sin fecha. Abra uno para darle una fecha.",
scheduleWork: "Programar trabajo",
scheduleSheetTitle: "¿Qué quieres programar?",
scheduleInspection: "Programar inspección",
scheduleJob: "Programar orden de trabajo",
filters: {
all: "Todo",
jobs: "Órdenes de trabajo",
inspections: "Inspecciones",
requests: "Solicitudes",
renewals: "Documentos",
},
prevRangeA11y: "Dos semanas anteriores",
nextRangeA11y: "Dos semanas siguientes",
upcoming: "Próximos",
modeMonth: "Mes",
modeWeek: "Semana",
modeMonthA11y: "Mostrar la cuadrícula del mes",
modeWeekA11y: "Mostrar la semana por horas",
prevWeekA11y: "Semana anterior",
nextWeekA11y: "Semana siguiente",
allDay: "Todo el día",
weekItemA11y: "{{type}} a las {{time}}: {{title}}",
},
itemKinds: {
job: "Orden de trabajo",
inspection: "Inspección",
request: "Solicitud",
document: "Documento",
condition: "Condición",
activity: "Actividad",
quick_action: "Acción rápida",
},
empty: "La cola está vacía.",
emptyLine: "No hay elementos en la cola para este ámbito.",
emptyBrowse: "Abrir Inspecciones",
emptyBrowseA11y: "Abrir el registro de Inspecciones",
searchPlaceholder: "Buscar por activo, ID, responsable",
ungroupedSite: "Otros",
hintFullLists: "Listas completas en Inspecciones y Órdenes de trabajo.",
context: {
followUpTitle: "Seguimiento",
toolsTitle: "Listas de control",
reportIssue: "Informar incidencia",
flagProblem: "Marcar riesgo o defecto",
requestFix: "Solicitar reparación",
escalate: "Escalar",
reusePrevious: "Reutilizar lista de control anterior",
moreFollowUps: "Más",
moreFollowUpsSheetTitle: "Registrar seguimiento o flujo de trabajo",
},
sections: {
queueTitle: "Cola",
overdue: "Atrasado · {{count}}",
dueToday: "Para hoy · {{count}}",
certificateActions: "Certificados por vencer · {{count}}",
scheduledInspections: "Inspecciones programadas · {{count}}",
inProgressJobs: "Órdenes de trabajo en curso · {{count}}",
needsAttention: "Requiere atención · {{count}}",
reportReviews: "Revisiones de informes",
},
},
assetCollaboration: {
  respondBy: {
    days: "{{count}} d",
    hours: "{{count}} h",
    minutes: "{{count}} min",
    overdue: "Atrasado {{window}}",
    dueIn: "Vence en {{window}}",
  },
  requestType: {
    job: "Orden de trabajo",
    inspection: "Inspección",
    help: "Ayuda",
  },
  requestPriority: {
    urgent: "Urgente",
    high: "Alta",
    medium: "Media",
    low: "Baja",
  },
  activityLabels: {
    lifecycleRecorded: "Registrado",
    lifecycleBulk: "Cambio masivo",
    team: "El equipo",
    shareRole: {
      requester: "Solicitante",
      viewer: "Lector",
    },
    shareStatus: {
      revoked: "Revocado",
      declined: "Rechazado",
      active: "Activo",
      pending: "Pendiente de aceptación",
    },
    sharedWithContact: "Compartido con un contacto",
    sharedWith: "Compartido con {{name}}",
    documentStatus: {
      no_expiry: "Sin fecha de vencimiento",
      expired: "Vencido",
      expiring_soon: "Vence pronto",
      valid: "Válido",
    },
    connectedState: {
      planned: "Registrado",
      outstanding: "Requiere atención",
      completed: "Resuelto",
    },
    connectedSource: "Fuente conectada",
    inspector: "Inspector",
    unassigned: "Sin asignar",
    scheduledInspection: "Inspección programada",
    type: {
      lifecycle: "Ciclo de vida",
      location: "Ubicación",
      access: "Acceso",
      connected: "Sistema conectado",
      document: "Documento",
      job: "Orden de trabajo",
      inspection: "Inspección",
    },
  },
  breadcrumbRequests: "Solicitudes",
  evidenceFromRequest: "Fotos de la solicitud",
  conversation: {
    empty: "Aún no hay mensajes. Envía uno abajo: {{who}} lo verá y responderá aquí.",
    noneExchanged: "No se enviaron mensajes en esta solicitud.",
  },
  closedBanner: {
    declinedRequester: "Esta solicitud se cerró sin seguir adelante.",
    declinedOp: "Esta solicitud se rechazó o se retiró.",
    doneRequester: "Todo listo: aceptaste el trabajo. No hay nada más que hacer.",
    doneOp: "El trabajo está hecho y aprobado. Esta solicitud está completa.",
    teamClosed: "El equipo cerró esta solicitud.",
    closedByTeam: "Tu equipo cerró esta solicitud. Toca Reabrir si queda algo por hacer.",
    closedByYou: "Cerraste esta solicitud. Toca Reabrir si queda algo por hacer.",
    titleNotProceeding: "Cerrada · No sigue adelante",
    titleDone: "Cerrada · Hecha",
  },
  tracker: {
    next: "Siguiente:",
    active: "Abierta hace {{age}}",
    closedTook: "Cerrada · tardó {{age}}",
    closed: "Cerrada",
    progressA11yNow: "Progreso: {{done}} de {{total}} pasos hechos, ahora {{stage}}",
    progressA11y: "Progreso: {{done}} de {{total}} pasos hechos",
  },
  row: {
    noAccountA11y: "enviada sin cuenta",
    noAccount: "Sin cuenta",
    contact: "Contacto",
    unassigned: "Sin asignar",
    team: "Equipo",
    assigned: "Asignada",
    preferred: "Preferida",
    scheduled: "Programada",
  },
  showAll_other: "Mostrar todo ({{count}})",
  showAll_many: "Mostrar todo ({{count}})",
  showAll_one: "Mostrar todo ({{count}})",
  showFewer: "Mostrar menos",
  messages: {
    newReplies_other: "{{count}} respuestas nuevas del equipo",
    newReplies_many: "{{count}} respuestas nuevas del equipo",
    newReplies_one: "{{count}} respuesta nueva del equipo",
    open: "Escribir al equipo",
    hide: "Ocultar mensajes",
  },
  period: {
    pm: "Tarde",
    am: "Mañana",
  },
  withdraw: {
    confirm: "Retirar",
    keep: "Mantenerla",
    body: "Esto cancela la solicitud y cualquier visita prevista, y avisa al equipo.",
    title: "¿Retirar esta solicitud?",
    button: "Retirar solicitud",
  },
  badge: {
    request: "Solicitud",
    job: "Orden de trabajo",
    inspection: "Inspección",
  },
  showDetailsA11y: "{{title}}. Mostrar detalles",
  hideDetailsA11y: "{{title}}. Ocultar detalles",
  collapseHide: "Ocultar",
  expandShow: "Mostrar",
  emptyAssetRequester: "Aún no has informado de nada sobre este activo.",
  sectionPendingRequester: "Enviadas: el equipo las está revisando",
  summary: {
    declined_other: "{{count}} rechazadas",
    declined_many: "{{count}} rechazadas",
    declined_one: "{{count}} rechazada",
    accepted_other: "{{count}} aceptadas",
    accepted_many: "{{count}} aceptadas",
    accepted_one: "{{count}} aceptada",
    planned_other: "{{count}} planificadas",
    planned_many: "{{count}} planificadas",
    planned_one: "{{count}} planificada",
    inProgress_other: "{{count}} en curso",
    inProgress_many: "{{count}} en curso",
    inProgress_one: "{{count}} en curso",
    withTeam_other: "{{count}} con el equipo",
    withTeam_many: "{{count}} con el equipo",
    withTeam_one: "{{count}} con el equipo",
    needsReply_other: "{{count}} necesitan tu respuesta",
    needsReply_many: "{{count}} necesitan tu respuesta",
    needsReply_one: "{{count}} necesita tu respuesta",
    toLookAt_other: "{{count}} por revisar",
    toLookAt_many: "{{count}} por revisar",
    toLookAt_one: "{{count}} por revisar",
  },
  progress: {
    reports_other: "{{count}} informes",
    reports_many: "{{count}} informes",
    reports_one: "{{count}} informe",
    inspections_other: "{{count}} inspecciones",
    inspections_many: "{{count}} inspecciones",
    inspections_one: "{{count}} inspección",
    jobs_other: "{{count}} trabajos",
    jobs_many: "{{count}} trabajos",
    jobs_one: "{{count}} trabajo",
  },
  sort: {
    updated: "Actualizadas hace poco",
    oldest: "Más antiguas",
    newest: "Más recientes",
  },
  displayStatus: {
    requester: {
      planned: "Planificada",
      accepted: "Aceptada",
      needsReview: "Necesita tu revisión",
      declined: "Rechazada",
      closed: "Cerrada",
      waiting: "Necesita tu respuesta",
      active: "En curso",
      triaged: "Aprobada",
      new: "Enviada",
    },
    operator: {
      declined: "Rechazada",
      closed: "Cerrada",
      waiting: "Esperando al solicitante",
      active: "En curso",
      triaged: "Aprobada",
      new: "Nueva",
    },
  },
  issueReportedConfirmInspection: "Incidencia registrada. Elige la lista y una hora para reservar la inspección.",
  issueReportedConfirmJob: "Incidencia registrada. Revisa el trabajo y créalo.",
  updateFailedTitle: "La solicitud no se actualizó",
  visitProposed: "Hora propuesta. Se pide al solicitante que la confirme.",
  requester: {
    contactMissing: "No pudimos vincular tu cuenta a este activo. Pide a quien lo compartió que lo vuelva a compartir.",
    assetMissing: "No encontramos este activo. Vuelve a abrir el enlace que recibiste.",
    submitFailedTitle: "Tu aviso no se envió",
    calendarTitle: "Inspección: {{name}}",
    reworkReason: "El solicitante pidió que se rehiciera el trabajo.",
    tryAgain: "Comprueba tu conexión e inténtalo de nuevo.",
    declineShareFailed: "No rechazado",
    acceptShareFailed: "No aceptado",
    withdrawFailed: "La solicitud no se retiró",
    sendFailed: "No enviado",
    confirmFailed: "No confirmado",
    reviewFailed: "Tu respuesta no se guardó",
    rescheduleFailed: "Tu nueva hora no se envió",
    confirmVisitFailed: "La visita no se confirmó",
    reportSent: "Aviso enviado. El equipo lo revisará; las novedades aparecen aquí y recibirás una notificación.",
    withdrawn: "Solicitud retirada. Se ha avisado al equipo.",
    preferredTimeSent: "Enviado. El equipo revisará la hora que prefieres y te responderá.",
    reworkRequested: "Devuelto al equipo. Tienen tu nota y volverán a ello.",
    completionAccepted: "Gracias, has aceptado el trabajo. El equipo cerrará la solicitud.",
    rescheduleSent: "Has pedido otra hora. El equipo propondrá una nueva.",
    visitConfirmed: "Visita confirmada. Se ha avisado al equipo.",
  },
  journey: {
    naReviewReport: "Revisa el informe y acepta el trabajo",
    naWaitingReviewOp: "Esperando la revisión del solicitante",
    naTeamCloses: "El equipo confirma y cierra el trabajo",
    naVerify: "Verifica el trabajo terminado",
    naWorkUnderway: "El trabajo está en curso",
    naWillSchedule: "El equipo programará el trabajo",
    naVisitAsPlanned: "El equipo irá según lo previsto",
    naConfirmVisit: "Confirma que alguien estará para la visita",
    naCarryOut: "Realiza el trabajo",
    naScheduleJob: "Programa e inicia el trabajo",
    naHelpOp: "Responde al solicitante o crea un trabajo",
    naStartInspection: "Inicia la inspección",
    naTeamArranging: "El equipo está organizando el trabajo",
    naPlanWork: "Planifica el trabajo",
    naCreateJob: "Crea el trabajo",
    naScheduleInspection: "Programa o inicia la inspección",
    naTeamReviewing: "El equipo está revisando tu solicitud",
    naTriage: "Aprueba, rechaza o haz una pregunta",
    naWaitingOnRequester: "Esperando al solicitante",
    naReplyToTeam: "Responder al equipo",
    detailTeamNote: "Nota del equipo: {{notes}}",
    detailReason: "Motivo: {{notes}}",
    slNewRequestOp: "Nueva solicitud.",
    slAllDone: "Todo listo.",
    slCompletedOp: "Completado.",
    slReadyForReview: "Listo para tu revisión.",
    slWaitingReviewOp: "Esperando la revisión del solicitante.",
    slAccepted: "Aceptaste el trabajo: el equipo lo confirma y lo cierra.",
    slAcceptedOp: "Aceptado por el solicitante: verifica y cierra.",
    slWorkUnderway: "El trabajo está en curso.",
    slWorkUnderwayOp: "Trabajo en curso.",
    slJobCreated: "Se ha creado un trabajo.",
    slJobCreatedOp: "Trabajo creado: aún sin programar.",
    slVisitPlanned: "Visita prevista para el {{when}}.",
    slJobPlannedOp: "Trabajo previsto para el {{when}}.",
    slHelp: "El equipo se está encargando.",
    slHelpOp: "Aprobada: responde o crea un trabajo.",
    slInspectionUnderway: "Hay una inspección en curso.",
    slInspectionUnderwayOp: "Inspección en curso.",
    slInspectionScheduled: "Inspección programada para el {{when}}.",
    slInspectionBookedOp: "Inspección reservada para el {{when}}.",
    slApproved: "Aprobada: el equipo está organizando el trabajo.",
    slApprovedOp: "Aprobada: organiza el trabajo.",
    slSubmitted: "Enviada.",
    slNewOp: "Nueva: revisa esta solicitud.",
    slWaitingOnRequester: "Esperando más información del solicitante.",
    slWaitingOnYou: "El equipo necesita algo más de información de tu parte.",
    slDeclined: "Esta solicitud se rechazó.",
    slDeclinedOp: "Rechazada.",
    stDone: "Hecho",
    stClose: "Cerrar",
    stYourReview: "Tu revisión",
    stReport: "Informe",
    stSignOff: "Aprobación",
    stAnswered: "Respondida",
    stAnswer: "Responder",
    stInProgress: "En curso",
    stWork: "Trabajo",
    stInspecting: "Inspeccionando",
    stInspect: "Inspeccionar",
    stPlanned: "Planificada",
    stSchedule: "Programar",
    stReviewed: "Revisada",
    stTriage: "Revisión",
    stRaised: "Enviada",
    stReceived: "Recibida",
  },
  requestConvert: {
    choose: "Elegir qué pasa ahora",
    inspectMeta: "Elige la lista de comprobación y una hora. La inspección queda reservada y vinculada a la solicitud.",
    jobMeta: "Comprueba quién lo hace, para cuándo y las instrucciones, y crea el trabajo.",
    inspectInstead: "Inspeccionar en su lugar",
    inspect: "Inspeccionar",
    jobInstead: "Crear un trabajo en su lugar",
    job: "Crear un trabajo",
    subtitle: "Los datos de la solicitud ya están rellenados. Solo confirmas quién lo hace y cuándo.",
    title: "¿Qué debe pasar ahora?",
  },
  requestFulfilment: {
    unclear: "No está claro qué falla: una inspección mostrará qué trabajo hace falta.",
    urgentUnclear: "Es urgente pero poco claro: envía a alguien ya y que lo revise allí.",
    readsAsCheck: "Parece una revisión de estado o seguridad, así que inspecciona primero.",
    describesFault: "Describe algo que arreglar, así que un trabajo es lo más rápido.",
    askedForJob: "Se pidió un trabajo.",
    askedForInspection: "Se pidió una inspección.",
    assessFirst: "Revísalo primero para saber qué trabajo hace falta.",
  },
tabLabel: "Seguimientos",
tabTitle: "Seguimientos y triaje",
tabIntro: "Registre seguimientos y revise solicitudes de contactos.",
openApprovalsQueue: "Ver todas las solicitudes en Trabajo",
sectionCardTitle: "Solicitudes de este activo",
sectionCardSub: "Registra un problema o mira todas las solicitudes en Trabajo.",
sectionCardSubRequester: "Informe de un problema y siga lo que ocurre con él.",
newRequest: "Nueva solicitud",
composeItemTitle: "Elemento de la lista de verificación de inspección",
composeItemDescription: "Ítem referenciado: {{itemId}}",
activityFollowUpLabel: "Elemento registrado",
activityAssetLabel: "Activo",
activityAssetCreatedTitle: "Activo añadido",
activityAssetCreatedStatus: "Creado",
activityAssistantChangeTitle: "Cambiado con el asistente",
activityAssistantUndoneTitle: "Cambio del asistente deshecho",
activityAssistantStatus: "Confirmado en el asistente",
activitySiteLabel: "Sitio",
missingAssetForCompose: "No se pudo encontrar este activo.",
missingLinkedContactForCompose: "No pudimos registrar la incidencia a tu nombre. Cierra sesión, vuelve a entrar e inténtalo de nuevo.",
operatorLinkedContactNoAccount: "Su perfil aún no está vinculado a una cuenta del espacio de trabajo. Cierre sesión y vuelva a entrar, o contacte con soporte.",
operatorLinkedContactAutoFailed: "No pudimos registrar la incidencia a tu nombre. Inténtalo en un momento; si sigue pasando, cierra sesión y vuelve a entrar.",
composeSubmitErrorTitle: "No se pudo enviar",
issueReported: "Incidencia registrada. Apruébala o toca Crear trabajo o Inspeccionar para planificar.",
composeSubmitErrorBody: "Inténtelo de nuevo.",
composeOpenErrorTitle: "No se puede abrir",
sectionPending: "Nuevas",
sectionAwaitingCustomer: "Necesita tu respuesta",
sectionAwaitingCustomerInternal: "Esperando al solicitante",
sectionActive: "Aprobadas, planificadas o en curso",
sectionClosed: "Cerradas",
sectionRejected: "Rechazadas",
emptyAsset: "Aún no hay nada informado sobre este activo. Toca Nueva solicitud para registrar un problema.",
loadingFollowUps: "Cargando seguimientos…",
emptySection: "Nada en este grupo.",
actionApprove: "Aprobar",
actionReject: "Rechazar",
actionSchedule: "Programar",
actionConvert: "Elegir tipo de trabajo",
metaContactFallback: "Contacto",
metaNoPriority: "Sin prioridad",
metaNoDate: "Sin momento preferido",
outcomeTypeJob: "Orden de trabajo con seguimiento",
outcomeTypeInspection: "Inspección programada",
},
followUpDetail: {
managerActionsTitle: "Acciones del responsable",
managerApprove: "Aprobar",
managerReject: "Rechazar",
managerSchedule: "Programar",
managerConvertJob: "Convertir en orden de trabajo",
managerConvertInspection: "Convertir en inspección",
summaryAssetHeadline: "Activo",
summaryRequesterHeadline: "Solicitante",
emptyLoadingTitle: "Cargando",
emptyLoadingBody: "Obteniendo el resumen y el historial más recientes.",
emptySelectTitle: "Seleccione un elemento",
emptySelectBody: "Seleccione un elemento para ver los detalles y las acciones.",
outcomeKindJob: "Registrado como trabajo",
outcomeKindInspection: "Inspección solicitada",
outcomeSummary: "Resumen",
fieldStatus: "Estado",
fieldPriority: "Prioridad",
fieldProposedDate: "Fecha preferida",
fieldScheduledFor: "Programado para",
fieldResolution: "Notas de resolución",
assetSummary: "Activo",
fieldAssetName: "Activo",
fieldAssetType: "Tipo",
fieldAssetStatus: "Estado del activo",
reporter: "Enviado por",
fieldContactName: "Nombre",
fieldContactEmail: "Correo electrónico",
timeline: "Progreso",
timelinePending: "Pendiente",
timelineDone: "Finalizado",
history: "Historial",
historyEmpty: "Aún no hay entradas en el historial.",
linkedWork: "Trabajo vinculado",
openLinkedJob: "Abrir orden de trabajo vinculada",
openLinkedInspection: "Abrir visita planificada",
actions: "Próximos pasos",
actionApprove: "Aprobar",
actionReject: "Rechazar",
actionSchedule: "Programar",
actionConvert: "Elegir la vía de trabajo",
loggedContext: "De dónde procede",
fieldSourceInspection: "Inspección",
fieldSourceJob: "Orden de trabajo",
fieldSourceSchedule: "Visita planificada",
fieldSourceLocation: "Nota de ubicación",
fieldIntent: "Cómo se registró",
intentReport: "Notificar un problema",
intentFlag: "Marcar problema",
intentRequestFix: "Solicitar reparación",
intentEscalate: "Escalar",
historyActionSubmitted: "Registrado para triaje",
historyActionApproved: "Aprobado",
historyActionRejected: "Rechazado",
historyActionScheduled: "Programado",
historyActionConvertedJob: "Orden de trabajo preparada a partir de la solicitud",
historyActionConvertedInspection: "Inspección preparada a partir de la solicitud",
historyActionCommented: "Comentario añadido",
aiAssistDisclosureTitle: "Asistencia y borradores",
aiAssistDisclosureSummary: "Resúmenes, reescrituras y respuestas sugeridas",
},
approvalsWorkspace: {
toolbarOpenAssetFollowUps: "Abrir seguimientos del activo",
toolbarChooseAsset: "Elegir activo",
searchPlaceholder: "Buscar por ID de activo",
applyAssetFilter: "Aplicar filtro de activo",
applyTeamFilter: "Aplicar filtro de equipo",
listColumnFollowUp: "Seguimiento",
listColumnStatus: "Estado",
listColumnPriority: "Prioridad",
listColumnDate: "Fecha",
listPaneTitle: "Solicitudes",
webStatusHint: "",
detailPaneTitle: "Detalle",
mobileTitle: "Solicitudes",
mobileSubtitle: "Triaje de seguimientos y preparación del trabajo.",
loadingQueue: "Cargando aprobaciones…",
emptyQueue: "No hay solicitudes aquí",
emptyQueueHint: "Pruebe los segmentos Enviadas o Todas, o amplíe el ámbito.",
filterInspection: "Inspección",
filterJob: "Orden de trabajo",
countPending: "Pendientes",
countUrgent: "Urgentes",
filterAssetPlaceholder: "Filtrar por ID de activo",
filterTeamPlaceholder: "Filtrar por ID de equipo",
statusFilterAll: "Todas",
statusFilterPending: "Pendiente",
statusFilterApproved: "Aprobada",
statusFilterScheduled: "Programada",
statusFilterConverted: "Trabajo vinculado",
statusFilterRejected: "Rechazada",
refine: "Refinar",
refineA11y: "Refinar los filtros de solicitudes",
refineSheetTitle: "Refinar solicitudes",
nameSearchPlaceholder: "Buscar solicitudes por nombre",
nameSearchA11y: "Buscar solicitudes por nombre",
},
requestComposer: {
  duplicateBodyMore_other: "«{{title}}» y {{count}} más siguen abiertas en este activo. Aun así puedes enviar la tuya.",
  duplicateBodyMore_many: "«{{title}}» y {{count}} más siguen abiertas en este activo. Aun así puedes enviar la tuya.",
  duplicateBodyMore_one: "«{{title}}» y {{count}} más siguen abiertas en este activo. Aun así puedes enviar la tuya.",
  duplicateBody: "«{{title}}» sigue abierta en este activo. Aun así puedes enviar la tuya.",
  duplicateSimilar: "Ya hay una solicitud similar abierta",
  duplicateExact: "Puede que ya se haya informado",
  summaryMissing: "Añade primero un resumen corto e inténtalo de nuevo.",
  ai: {
    signInBody: "Tu sesión terminó. Vuelve a iniciar sesión y añade la foto.",
    signInTitle: "Inicia sesión para añadir fotos",
    failedBody: "Inténtalo en un momento o deja lo que escribiste.",
    failedTitle: "No se pudo mejorar el texto",
    review: "Revísalo antes de usarlo.",
    titleTitle: "Resumen mejorado",
    detailsTitle: "Detalles mejorados",
  },
titles: {
default: "Informar de un problema",
report: "Informar incidencia",
flag: "Marcar problema",
requestFix: "Solicitar reparación",
escalate: "Escalar",
followUp: "Proponer un seguimiento",
rework: "Proponer una corrección",
quote: "Ofrecer un presupuesto",
},
proposal: {
kindHeading: "¿Qué propones?",
kindFollowUp: "Seguimiento",
kindRework: "Corrección",
kindQuote: "Un presupuesto",
summaryPlaceholder: "p. ej. Sustituir la válvula de presión",
detailsLabel: "Qué hay que hacer y por qué",
detailsPlaceholder: "Lo que encontraste, lo que harías y lo que deberían saber",
submit: "Enviar propuesta",
},
close: "Cerrar",
assetHeading: "Activo",
assetChoose: "Elegir un activo",
assetSearchPlaceholder: "Buscar por nombre del activo…",
assetTypeAll: "Todos los tipos",
assetNoMatches: "Ningún activo coincide con la búsqueda y los filtros.",
dictate: "Dictar",
dictationListening: "Escuchando…",
dictationProcessing: "Insertando transcripción…",
dictationStopping: "Finalizando dictado…",
dictationHeard: "Se oyó: {{text}}",
aiPolish: "Mejorar con IA",
contextHeading: "Contexto",
contextReporter: "Informador: {{name}}",
contextInspection: "De una inspección",
contextJob: "De una orden de trabajo",
contextSchedule: "De una visita prevista",
outcomeHeading: "¿Qué necesitas?",
outcomeHelp: "Solo ayuda — aún no lo sé",
outcomeJob: "Una orden de trabajo",
outcomeInspection: "Solicitar una inspección",
summaryLabel: "Resumen breve",
summaryPlaceholder: "p. ej., fallo en la válvula",
detailsLabel: "Qué has visto",
summaryPlaceholderRequester: "p. ej. El grifo de la cocina gotea",
detailsLabelRequester: "¿Qué ocurre?",
detailsPlaceholderRequester: "Qué ha notado, dónde está y desde cuándo",
detailsPlaceholder: "Observaciones, riesgo y restricciones",
priorityLabel: "Prioridad",
priorityNone: "Ninguna",
priorityPickerTitle: "Prioridad",
proposedDateLabel: "Momento preferido (opcional)",
proposedDatePlaceholder: "Seleccionar fecha",
submit: "Enviar",
submitRequester: "Enviar aviso",
submitting: "Enviando…",
assetChangeAccessibility: "Cambiar de activo",
assetChange: "Cambiar",
analyzeEvidence: "Leer las fotos",
evidenceAddToDetails: "Añadir el texto extraído a los detalles",
},
followUpActionModal: {
  stop: "Detener",
  draft: "Redactar con IA",
  drafting: "Redactando…",
  polishFailedBody: "Inténtalo de nuevo en un momento.",
  polishFailedTitle: "No se pudo mejorar la nota",
  draftFailedBody: "Inténtalo de nuevo o escríbela tú.",
  draftFailedTitle: "No se pudo redactar una pregunta",
  polishReview: "Revisa la nota antes de usarla.",
  draftReview: "Revísala antes de enviarla.",
  draftedMessageTitle: "Pregunta redactada",
  polishedNotesTitle: "Nota mejorada",
  phNotes: "Lo que deba saber, como cuándo irá alguien.",
  phReject: "Por qué no seguirá adelante. El solicitante lo ve.",
  phClose: "¿Por qué se cierra? Se guarda en la solicitud.",
  phReplied: "Su respuesta, tal como la dio por correo o teléfono. Se guarda en la solicitud.",
  phAsk: "¿Qué necesitas de ellos? Lo reciben por correo o en la app.",
  labelNotes: "Nota para el solicitante (opcional, la ve)",
  labelReject: "Motivo (el solicitante lo ve)",
  labelClose: "Motivo del cierre (opcional, el solicitante lo ve)",
  labelReplied: "Lo que dijo (opcional)",
  labelAsk: "Tu pregunta (el solicitante la ve)",
  aiFallbackLabel: "Solicitud",
  loadAssigneesFailed: "No se pudieron cargar las personas que puedes asignar. Inténtalo de nuevo.",
  searchAssignees: "Buscar personas",
  loadingAssignees: "Cargando personas…",
  unassigned: "Nadie todavía",
  confirmSchedule: "Proponer esta hora",
  confirmClose: "Cerrar solicitud",
  confirmReplied: "Guardar su respuesta",
  confirmAsk: "Enviar pregunta",
  confirmReject: "Rechazar solicitud",
  confirmApprove: "Aprobar",
  closeTitle: "Cerrar solicitud",
  repliedTitle: "Registrar su respuesta",
  askTitle: "Hacer una pregunta al solicitante",
approveTitle: "Aprobar solicitud",
rejectTitle: "Rechazar solicitud",
scheduleTitle: "Programar trabajo",
convertTitle: "Elegir la vía de trabajo",
cancel: "Cancelar",
confirm: "Confirmar",
saving: "Guardando…",
targetLabel: "Tipo de resultado",
targetJob: "Orden de trabajo con seguimiento",
targetInspection: "Inspección programada",
convertPickerTitle: "Elegir la vía",
},
inspections: {
screenTitle: "Inspecciones",
templates: "Listas de control",
runner: {
noItems: "Sin elementos",
noItemsInGroup: "Sin elementos en este grupo",
items_one: "{{count}} elemento",
items_other: "{{count}} elementos",
groups_one: "{{count}} grupo",
groups_other: "{{count}} grupos",
questions_one: "{{count}} pregunta",
questions_other: "{{count}} preguntas",
questionsShort: "{{count}} preg.",
groupOf: "Grupo {{index}} de {{total}}",
groupOfShort: "Grupo {{index}}/{{total}}",
itemOf: "Elemento {{index}} de {{total}}",
indexOfShort: "{{index}}/{{total}}",
inGroup: "En: {{group}}",
items_many: "{{count}} elementos",
groups_many: "{{count}} grupos",
questions_many: "{{count}} preguntas",
},
bulk: {
select: "Seleccionar inspecciones",
selectA11y: "Seleccionar varias inspecciones para acciones masivas",
cancelSelection: "Cancelar",
selected_one: "{{count}} seleccionada",
selected_other: "{{count}} seleccionadas",
selectAllVisible: "Todas las visibles",
clearVisible: "Deseleccionar visibles",
selectAllA11y: "Seleccionar todas las inspecciones visibles",
deselectAllA11y: "Deseleccionar todas las inspecciones visibles",
deleteInspections: "Eliminar",
deleteConfirmTitle: "Eliminar inspecciones",
deleteConfirmMessage_one: "¿Eliminar {{count}} inspección? Esta acción no se puede deshacer.",
deleteConfirmMessage_other: "¿Eliminar {{count}} inspecciones? Esta acción no se puede deshacer.",
deleteConfirmAction: "Eliminar",
keep: "Conservar",
deleteSuccess_one: "Se eliminó {{count}} inspección",
deleteSuccess_other: "Se eliminaron {{count}} inspecciones",
partialResult: "{{succeeded}} completadas · {{failed}} omitidas",
allFailedTitle: "No hubo cambios",
allFailedMessage: "No se pudieron eliminar las inspecciones seleccionadas. Inténtelo de nuevo.",
selected_many: "{{count}} seleccionadas",
deleteConfirmMessage_many: "¿Eliminar {{count}} inspecciones? Esta acción no se puede deshacer.",
deleteSuccess_many: "Se eliminaron {{count}} inspecciones",
},
createInspection: "Crear inspección",
startInspection: "Iniciar inspección",
searchA11y: "Buscar inspecciones",
searchPlaceholderPlanned: "¿Buscar inspecciones planificadas?",
searchPlaceholderDefault: "¿Buscar inspecciones y revisiones?",
export: "Exportar",
exportCsvA11y: "Exportar inspecciones como CSV",
refine: "Refinar",
refineA11y: "Refinar filtros y agrupación",
refineSheetTitle: "Refinar inspecciones",
refineSearch: "Buscar",
clearFilters: "Borrar filtros",
manageTemplates: "Listas de control",
statusSectionLabel: "Estado",
bucketTablistLabel: "Estado de la inspección: Todos, Requiere acción, Planificado o Historial",
statusHintLine: "La lista coincide con este estado.",
viewToggleToListA11y: "Cambiar inspecciones planificadas a vista de lista",
viewToggleToCalendarA11y: "Cambiar inspecciones planificadas a vista de calendario",
buckets: {
all: "Todos",
needsAction: "Requiere acción",
planned: "Planificado",
history: "Completado",
},
subtitles: {
allNone: "Aún no hay inspecciones",
allCount_one: "{{count}} inspección",
allCount_other: "{{count}} inspecciones",
needsActionNone: "No se requiere acción ahora",
needsActionCount_one: "{{count}} elemento necesita atención",
needsActionCount_other: "{{count}} elementos necesitan atención",
plannedNone: "No hay inspecciones planificadas",
plannedCount_one: "{{count}} inspección próxima",
plannedCount_other: "{{count}} inspecciones próximas",
historyNone: "Aún no hay historial de inspecciones",
historyCount_one: "{{count}} elemento completado, aprobado o revisado",
historyCount_other: "{{count}} elementos completados, aprobados o revisados",
allCount_many: "{{count}} inspecciones",
needsActionCount_many: "{{count}} elementos necesitan atención",
plannedCount_many: "{{count}} inspecciones próximas",
historyCount_many: "{{count}} elementos completados, aprobados o revisados",
},
emptyFilteredTitle: "No hay coincidencias",
emptyFilteredSubtitle: "Pruebe otros términos o borre los filtros de refinamiento.",
emptyPlannedTitle: "No hay inspecciones en Planificado",
emptyPlannedSubtitle: "Programe una inspección para que aparezca aquí.",
emptyCalendarTitle: "No hay inspecciones programadas",
emptyCalendarSubtitle: "El calendario muestra las inspecciones con fecha programada. Cambie a Tarjetas o Lista para ver aquí todas las inspecciones.",
emptyHistoryTitle: "No hay inspecciones en Historial",
emptyHistorySubtitle: "Las inspecciones completadas y revisadas aparecen aquí al finalizar.",
emptyAllTitle: "Aún no hay inspecciones",
emptyAllSubtitle: "Aquí aparecen las inspecciones, revisiones y programaciones.",
emptyNeedsActionTitle: "Ahora mismo no hay nada que requiera su atención",
emptyNeedsActionSubtitle: "Cuando una inspección necesite su atención, aparecerá en esta lista.",
followUp: {
logFromItem: "Registrar desde elemento de lista",
},
refineScope: "Ámbito",
refineGroupBy: "Agrupar por",
refineGroupByHint: "Seleccione una o más opciones para anidar grupos",
refineFilters: "Filtros",
refineInspectionStage: "Fase de inspección",
refineScheduleStage: "Fase de programación",
filterChipAsset: "Activo",
filterChipTemplate: "Lista de control",
filterChipInspector: "Inspector",
groupByAsset: "Activo",
groupByInspector: "Inspector",
groupByTemplateCategory: "Categoría de lista de control",
groupingUnassigned: "Sin asignar",
groupingUncategorized: "Sin categoría",
inspectorAll: "Todos",
inspectorMe: "Yo",
inspectionStages: {
all: "Todas las fases de inspección",
allShort: "Todas las fases",
draft: "Borrador",
inProgress: "En curso",
completed: "Completada",
approved: "Aprobada",
cancelled: "Cancelada",
},
scheduleStages: {
all: "Todas las fases de programación",
allShort: "Todas",
upcoming: "Próximas",
due: "Vencidas",
overdue: "Atrasadas",
},
reviewStages: {
pending: "Revisión pendiente",
responded: "Revisión respondida",
awaitingReply: "Compartida — esperando respuesta",
awaitingVerification: "Esperando verificación",
column: {
triage: "Abierta",
scheduled: "Programada",
in_progress: "En curso",
awaiting_review: "Pendiente de revisión",
},
},
kanban: {
dueAndOverdue: "Por vencer y vencidas",
},
workflowStage: {
draft: "Borrador",
in_progress: "En curso",
completed: "Completada",
approved: "Aprobada",
cancelled: "Cancelada",
},
pickerAllTemplates: "Todas las listas de control",
pickerTitleAsset: "Activo",
pickerTitleTemplate: "Lista de control",
pickerTitleInspector: "Inspector",
reviewFallbackReport: "Informe de inspección",
reviewFallbackAsset: "Activo",
reviewStatusApproved: "Aprobada",
reviewStatusDeclined: "Rechazada",
reviewStatusPending: "Revisión pendiente",
resultsPanelA11y: "Resultados de inspección del segmento seleccionado",
fabCreateA11y: "Crear inspección",
exportCsv: {
id: "ID",
template: "Lista de control",
asset: "Activo",
status: "Estado",
stage: "Fase",
assignee: "Asignado",
lastActivity: "Última actividad",
},
operationalInsight: {
title: "Información del registro de inspecciones",
sourceLabel: "Inspecciones, programaciones y revisiones existentes",
summaryLine: "{{bucketNeedsAction}} requieren atención · {{planned}} programadas · {{history}} completadas en este ámbito",
overdueSchedExplanation_one: "{{count}} inspección programada está vencida.",
overdueSchedExplanation_many: "{{count}} inspecciones programadas están vencidas.",
overdueSchedExplanation_other: "{{count}} inspecciones programadas están vencidas.",
overdueSchedRecommended: "Inícielas o reprográmelas para mantener la cobertura y el cumplimiento.",
overdueSchedCta: "Mostrar programaciones vencidas",
pendingReviewExplanation_one: "{{count}} informe compartido espera la respuesta de un revisor.",
pendingReviewExplanation_many: "{{count}} informes compartidos esperan la respuesta de un revisor.",
pendingReviewExplanation_other: "{{count}} informes compartidos esperan la respuesta de un revisor.",
pendingReviewRecommended: "Responda o recuerde a los revisores para que las aprobaciones no se bloqueen.",
pendingReviewCta: "Abrir siguiente revisión",
dueSoonExplanation_one: "{{count}} inspección programada vence pronto.",
dueSoonExplanation_many: "{{count}} inspecciones programadas vencen pronto.",
dueSoonExplanation_other: "{{count}} inspecciones programadas vencen pronto.",
dueSoonRecommended: "Confirme quién las realizará y registre el trabajo previo necesario.",
dueSoonCta: "Mostrar programaciones próximas a vencer",
inProgressExplanation_one: "{{count}} inspección está en borrador o en curso.",
inProgressExplanation_many: "{{count}} inspecciones están en borrador o en curso.",
inProgressExplanation_other: "{{count}} inspecciones están en borrador o en curso.",
inProgressRecommended: "Continúe las listas de verificación, registre evidencias y traspase si es necesario.",
inProgressCta: "Centrarse en las que están en curso",
healthyExplanation: "No hay revisiones pendientes ni programaciones vencidas en esta vista filtrada.",
healthyRecommended: "Use Refinar para cambiar el ámbito, la agrupación o la búsqueda cuando necesite una lista más acotada.",
refineCta: "Abrir Refinar",
exportCsvLabel: "Exportar inspecciones (CSV)",
wideCollapsedLead: "Expanda para ver las acciones.",
widePanelLead: "Las acciones corresponden a esta vista.",
},
tableHeaderWorkItem: "Elemento de trabajo",
tableHeaderStatus: "Estado",
tableHeaderAssigned: "Asignado",
tableHeaderDueDate: "Fecha de vencimiento",
},
templates: {
  addIndustryPack: "Añadir un paquete del sector",
  emptyNoneSubtitlePacks: "Añada las listas de verificación ya preparadas para su sector o cree la suya.",
screenTitle: "Listas de control",
createManually: "Crear manualmente",
createManuallyA11y: "Crear manualmente",
refineScope: "Alcance",
subtitleCount_one: "{{count}} lista de control",
subtitleCount_other: "{{count}} listas de control",
fromPack_one: "{{count}} del paquete {{pack}}",
fromPack_many: "{{count}} del paquete {{pack}}",
fromPack_other: "{{count}} del paquete {{pack}}",
inspectionsLink: "Inspecciones",
searchPlaceholder: "Buscar listas de control...",
searchPlaceholderWeb: "Buscar listas de control, categorías o descripciones",
searchA11y: "Buscar listas de control",
refine: "Refinar",
refineSheetTitle: "Refinar listas de control",
refineGroupBy: "Agrupar por",
refineGroupByHint: "Seleccione uno o más para anidar grupos",
refineFilters: "Filtros",
filterAssetType: "Tipo de activo",
filterCategory: "Categoría",
groupByAssetType: "Tipo de activo",
groupByCategory: "Categoría",
pickerTitleAssetType: "Tipo de activo",
pickerTitleCategory: "Categoría",
allTypes: "Todos los tipos",
allCategories: "Todas las categorías",
statusSectionLabel: "Estado",
bucketTablistLabel: "Estado de la lista de control: Requiere acción, Planificada o Historial",
statusHintLine: "Requiere acción, planificadas e historial.",
refineA11y: "Refinar los filtros de listas de control",
clear: "Borrar",
clearA11y: "Borrar búsqueda y filtros",
generateWithAi: "Generar con IA",
createChooserTitle: "Crear lista de control",
createChooserSubtitle: "Elija cómo crear su lista de control.",
newTemplate: "Nueva lista de control",
createTemplate: "Crear lista de control",
createTemplateA11y: "Crear lista de control",
newTemplateA11y: "Nueva lista de control",
emptyNoneTitle: "Aún no hay listas de control de lista",
emptyNoneSubtitle: "Cree una lista de control de lista de verificación.",
emptyFilteredTitle: "Sin listas de control coincidentes",
emptyFilteredSub: "Pruebe otros términos de búsqueda o borre los filtros.",
clearFilters: "Borrar filtros",
emptyBucketTitle: "Sin listas de control en {{bucket}}",
emptyBucketSub: "Cambie de pestaña o borre los filtros.",
goToNeedsAction: "Ir a Requiere acción",
goToNeedsActionA11y: "Mostrar listas de control en Requiere acción",
inspectorHeading: "Inspector",
compatibility: "Compatibilidad",
versioning: "Control de versiones",
structure: "Estructura",
visibility: "Visibilidad",
description: "Descripción",
versioningCurrentId: "ID de la versión actual: {{id}}",
versioningNotSet: "No establecido",
lastUpdatedPrefix: "Última actualización",
structureLine: "{{groups}} grupos / {{items}} elementos / {{conditional}} reglas condicionales",
requiredChecks_one: "{{count}} comprobación obligatoria",
requiredChecks_many: "{{count}} comprobaciones obligatorias",
requiredChecks_other: "{{count}} comprobaciones obligatorias",
visibilityAllTeams: "Todos los equipos",
visibilitySelectedTeams: "Equipos seleccionados",
openTemplate: "Abrir lista de control",
edit: "Editar",
useForInspection: "Iniciar inspección",
detail: {
duplicate: "Duplicar",
delete: "Eliminar",
sharedBadge: "Compartida",
notFound: "Lista de control no encontrada",
restrictToSelectedTeams: "Restringir a los equipos seleccionados",
shareWithAllTeams: "Compartir con todos los equipos",
visibleToAllTeams: "Visible para todos los equipos",
deleteConfirmTitle: "Eliminar lista de control",
deleteConfirmBody: "¿Eliminar “{{name}}”? Las inspecciones anteriores que la usaron conservarán su registro.",
cancel: "Cancelar",
duplicatedTitle: "Duplicada",
duplicatedBody: "Se ha creado una copia de esta lista de control.",
errorTitle: "Algo salió mal",
failedToDelete: "No se pudo eliminar esta lista de control. Inténtelo de nuevo.",
failedToDuplicate: "No se pudo duplicar esta lista de control. Inténtelo de nuevo.",
failedToUpdate: "No se pudo actualizar esta lista de control. Inténtelo de nuevo.",
usedByTitle: "Utilizada en",
usedByCount_one: "{{count}} inspección",
usedByCount_other: "{{count}} inspecciones",
usedByEmpty: "Ninguna inspección ha usado esta lista de control todavía.",
usedByOpenInspection: "Abrir inspección",
usedByCount_many: "{{count}} inspecciones",
},
selectTemplateTitle: "Seleccione una lista de control",
selectTemplateSub: "Elija una fila para revisar su estructura, versiones y acciones de uso.",
groupingUncategorized: "Sin categoría",
labelGeneral: "General",
labelAllAssets: "Todos los activos",
fabNewTemplateA11y: "Nueva lista de control",
buckets: {
all: "Todas",
needsAction: "Requiere acción",
planned: "Planificada",
history: "Historial",
},
subtitleCount_many: "{{count}} listas de control",
},
jobs: {
followUp: {
requestFix: "Solicitar reparación",
escalate: "Escalar",
logForTriage: "Registrar seguimiento",
logForTriageHint: "Abre los seguimientos de este activo con el contexto de la orden de trabajo para Aprobaciones.",
},
operationalInsight: {
summaryEmpty: "Ninguna orden de trabajo coincide con el ámbito y los filtros actuales.",
summaryCounts: "{{total}} órdenes de trabajo en esta vista · {{overdue}} vencidas · {{unassigned}} sin asignar · {{unscheduled}} sin fecha de inicio programada",
overdueExplanation_one: "{{count}} orden de trabajo ha superado su fecha de inicio o vencimiento programada.",
overdueExplanation_many: "{{count}} órdenes de trabajo han superado su fecha de inicio o vencimiento programada.",
overdueExplanation_other: "{{count}} órdenes de trabajo han superado su fecha de inicio o vencimiento programada.",
overdueRecommended: "Confirme el responsable, reprograme o cierre el trabajo que ya esté hecho.",
overdueCta: "Mostrar vencidas",
unassignedExplanation_one: "{{count}} orden de trabajo abierta no tiene responsable asignado.",
unassignedExplanation_many: "{{count}} órdenes de trabajo abiertas no tienen responsable asignado.",
unassignedExplanation_other: "{{count}} órdenes de trabajo abiertas no tienen responsable asignado.",
unassignedRecommended: "Asigne cada orden de trabajo para que responsables, clientes y contratistas sepan quién dirige el trabajo.",
unassignedCta: "Mostrar sin asignar",
unscheduledExplanation_one: "{{count}} orden de trabajo aceptada aún necesita una fecha de inicio programada.",
unscheduledExplanation_many: "{{count}} órdenes de trabajo aceptadas aún necesitan una fecha de inicio programada.",
unscheduledExplanation_other: "{{count}} órdenes de trabajo aceptadas aún necesitan una fecha de inicio programada.",
unscheduledRecommended: "Establezca una ventana de inicio antes de que el trabajo se retrase o entre en conflicto con otros compromisos.",
unscheduledCta: "Mostrar sin programar",
urgentExplanation_one: "{{count}} orden de trabajo está marcada con urgencia alta.",
urgentExplanation_many: "{{count}} órdenes de trabajo están marcadas con urgencia alta.",
urgentExplanation_other: "{{count}} órdenes de trabajo están marcadas con urgencia alta.",
urgentRecommended: "Revise si hay bloqueos, evidencias faltantes y retrasos visibles para el cliente.",
urgentCta: "Filtrar urgencia alta",
healthyExplanation: "No hay órdenes de trabajo vencidas, sin asignar ni sin programar en esta vista filtrada.",
healthyRecommended: "Mantenga las fechas, los responsables y las actualizaciones al día a medida que avanza el trabajo.",
healthyCta: "Refinar filtros",
exportCsvLabel: "Exportar órdenes de trabajo visibles (CSV)",
wideCollapsedLead: "Expanda para ver las acciones.",
widePanelLead: "Las acciones corresponden a esta vista.",
},
screenTitle: "Órdenes de trabajo",
createJob: "Crear orden de trabajo",
createJobA11y: "Crear orden de trabajo",
searchPlaceholder: "Buscar órdenes de trabajo...",
searchPlaceholderWeb: "Buscar órdenes de trabajo, activos, responsables...",
searchA11y: "Buscar órdenes de trabajo",
refine: "Refinar",
refineSheetTitle: "Refinar órdenes de trabajo",
refineSearch: "Buscar",
refineJobsA11y: "Refinar los filtros de órdenes de trabajo",
refineScope: "Ámbito",
refineGroupBy: "Agrupar por",
refineGroupByHint: "Seleccione uno o más para anidar grupos",
refineFilters: "Filtros",
refineStage: "Fase",
refineQuoteWorkflow: "Flujo de presupuesto",
clearFilters: "Borrar filtros",
advancedFiltersTitle: "Filtros avanzados y orden",
advancedFiltersSummary_one: "{{count}} filtro activo",
advancedFiltersSummary_other: "{{count}} filtros activos",
advancedFiltersSummaryEmpty: "Agrupar por, filtros, fase, ámbito, orden",
advancedFiltersExpand: "Mostrar filtros",
advancedFiltersCollapse: "Ocultar filtros",
exportFilteredCsvA11y: "Exportar las órdenes de trabajo filtradas actualmente como CSV",
statusSectionLabel: "Estado",
bucketTablistLabel: "Estado de la orden de trabajo: Todas, Requiere acción, Planificada o Historial",
statusHintLine: "La cola coincide con este grupo.",
switchToListA11y: "Cambiar las órdenes de trabajo a vista de lista",
switchToCalendarA11y: "Cambiar las órdenes de trabajo a vista de calendario",
bucketsNative: {
all: "Todas",
needs_action: "Requiere acción",
scheduled: "Programada",
closed: "Cerrada",
},
bucketsWeb: {
all: "Todas",
needs_action: "Requiere acción",
scheduled: "Planificada",
closed: "Historial",
},
sort: {
newest: "Más recientes primero",
oldest: "Más antiguas primero",
name_az: "Nombre A-Z",
name_za: "Nombre Z-A",
asset_name: "Nombre del activo",
highest_cost: "Coste más alto",
lowest_cost: "Coste más bajo",
assignee: "Responsable",
},
sortBy: "Ordenar por",
groupBy: {
asset: "Activo",
status: "Estado",
},
attention: {
all: "Todas",
overdue: "Vencidas",
unscheduled: "Sin programar",
},
webQueue: {
all: "Todas activas",
overdue: "Vencidas",
awaiting_acceptance: "Esperando aceptación",
unscheduled: "Sin programar",
in_progress: "En curso",
due_soon: "Vencen pronto",
other: "Programadas más adelante",
},
quoteState: {
all: "Todos los estados de presupuesto",
awaiting_request: "Esperando solicitud de presupuesto",
requested: "Solicitud de presupuesto vinculada",
awarded: "Presupuesto adjudicado",
},
quoteLinked: "Vinculado",
quoteNone: "Ninguno",
priority: {
all: "Todas",
low: "Baja",
medium: "Media",
high: "Alta",
critical: "Crítica",
},
deliveryAll: "Todos",
deliveryMode: {
INTERNAL: "Interno",
DIRECT_CONTRACTOR: "Contratista directo",
PRIVATE_QUOTES: "Presupuestos privados",
},
categoryAll: "Todas las categorías",
assigneeAll: "Todos los responsables",
assigneeUnassigned: "Sin asignar",
assigneeAssignedFallback: "Asignado",
filterChip: {
asset: "Activo",
category: "Categoría",
workPath: "Vía de trabajo",
priority: "Prioridad",
attention: "Atención",
sort: "Orden",
assignee: "Responsable",
quoteState: "Estado del presupuesto",
},
pickerTitle: {
asset: "Activo",
category: "Categoría",
workPath: "Vía de trabajo",
priority: "Prioridad",
sortBy: "Ordenar por",
attention: "Atención",
assignee: "Responsable",
quoteState: "Estado del presupuesto",
},
stages: {
all: {
all: "Todas",
},
needs_action: {
all: "Todas",
draft: "Borrador",
open: "Abierta",
accepted: "Aceptada",
completed: "Completada",
rejected: "Rechazada",
},
scheduled: {
all: "Todas",
scheduled: "Programada",
in_progress: "En curso",
paused: "En pausa",
},
closed: {
all: "Todas",
verified: "Verificada",
cancelled: "Cancelada",
},
},
grouping: {
noAsset: "Sin activo",
noSkill: "Sin especialidad",
unassigned: "Sin asignar",
uncategorized: "Sin categoría",
},
analytics: {
assigneeChannel: {
unassigned: "Sin asignar",
team_member: "Miembro del equipo",
contractor: "Contratista",
type_unset: "Responsable (tipo sin definir)",
},
privateQuotesPipeline: {
awaitingRequest: "Aún sin solicitud de presupuesto",
requested: "Esperando adjudicación",
awarded: "Presupuesto adjudicado (en curso)",
},
notSet: "No establecido",
},
urgency: {
normal: "Normal",
low: "Baja",
medium: "Media",
high: "Alta",
},
relative: {
justNow: "Ahora mismo",
minutesAgo: "hace {{count}} min",
hoursAgo: "hace {{count}} h",
},
sortDash: "-",
alerts: {
cancelTitle: "Cancelar orden de trabajo",
cancelMessage: "¿Está seguro? La orden de trabajo se marcará como cancelada.",
keep: "Conservar",
cancelConfirm: "Cancelar orden de trabajo",
deleteTitle: "Eliminar orden de trabajo",
deleteMessage: "Esta acción no se puede deshacer. La orden de trabajo se eliminará de forma permanente.",
deleteConfirm: "Eliminar",
errorTitle: "Error",
failedCancel: "No se pudo cancelar",
failedDelete: "No se pudo eliminar",
acceptFailedTitle: "No se pudo aceptar la orden de trabajo",
acceptFailedMessage: "Inténtelo de nuevo.",
},
bulk: {
select: "Seleccionar órdenes de trabajo",
selectA11y: "Seleccionar varias órdenes de trabajo para acciones masivas",
cancelSelection: "Cancelar",
selected_one: "{{count}} seleccionada",
selected_other: "{{count}} seleccionadas",
selectAllVisible: "Todas las visibles",
clearVisible: "Deseleccionar visibles",
selectAllA11y: "Seleccionar todas las órdenes de trabajo visibles",
deselectAllA11y: "Deseleccionar todas las órdenes de trabajo visibles",
cancelJobs: "Cancelar",
deleteJobs: "Eliminar",
cancelConfirmTitle: "Cancelar órdenes de trabajo",
cancelConfirmMessage_one: "¿Cancelar {{count}} orden de trabajo? Se marcará como cancelada.",
cancelConfirmMessage_other: "¿Cancelar {{count}} órdenes de trabajo? Se marcarán como canceladas.",
cancelConfirmAction: "Cancelar órdenes de trabajo",
deleteConfirmTitle: "Eliminar órdenes de trabajo",
deleteConfirmMessage_one: "¿Eliminar {{count}} orden de trabajo? Esta acción no se puede deshacer.",
deleteConfirmMessage_other: "¿Eliminar {{count}} órdenes de trabajo? Esta acción no se puede deshacer.",
deleteConfirmAction: "Eliminar",
keep: "Conservar",
noneCancellable: "Ninguna de las órdenes de trabajo seleccionadas se puede cancelar.",
cancelSuccess_one: "Se canceló {{count}} orden de trabajo",
cancelSuccess_other: "Se cancelaron {{count}} órdenes de trabajo",
deleteSuccess_one: "Se eliminó {{count}} orden de trabajo",
deleteSuccess_other: "Se eliminaron {{count}} órdenes de trabajo",
partialResult: "{{succeeded}} completadas · {{failed}} omitidas",
allFailedTitle: "No hubo cambios",
allFailedMessage: "No se pudieron actualizar las órdenes de trabajo seleccionadas. Inténtelo de nuevo.",
selected_many: "{{count}} seleccionadas",
cancelConfirmMessage_many: "¿Cancelar {{count}} órdenes de trabajo? Se marcarán como canceladas.",
deleteConfirmMessage_many: "¿Eliminar {{count}} órdenes de trabajo? Esta acción no se puede deshacer.",
cancelSuccess_many: "Se cancelaron {{count}} órdenes de trabajo",
deleteSuccess_many: "Se eliminaron {{count}} órdenes de trabajo",
},
emptyNoJobs: "Sin órdenes de trabajo",
emptyNoMatching: "Sin órdenes de trabajo coincidentes",
emptyFilteredHint: "Pruebe otros términos de búsqueda o borre los filtros.",
subtitleAttentionSummary: "{{overdue}} vencidas · {{unscheduled}} sin programar",
webSubtitleSummary: "{{total}} órdenes de trabajo · {{overdue}} vencidas · {{inProgress}} en curso · {{dueSoon}} vencen pronto",
noAssetLinked: "Sin activo vinculado",
metaAsset: "Activo",
metaPriority: "Prioridad",
overview: {
queue: "Cola",
status: "Estado",
assignee: "Responsable",
workPath: "Vía de trabajo",
schedule: "Programación",
nextStep: "Siguiente paso",
started: "Iniciada",
completed: "Completada",
duration: "Duración",
quoteState: "Estado del presupuesto",
summary: "Resumen",
inspection: "Inspección",
},
notSet: "no establecido",
emDash: "—",
nextStepFallback: "Revisar en los detalles completos",
workflowNextStep: {
awaitingFollowOn: "Esperando aprobación de seguimiento",
draft: "Revisar los detalles y abrir la orden de trabajo",
openAwaitingAcceptance: "Aceptar o rechazar la orden de trabajo",
openSchedule: "Programar orden de trabajo",
openAssign: "Asignar orden de trabajo",
rejected: "Revisar el rechazo y reasignar",
scheduled: "Iniciar orden de trabajo",
inProgress: "Completar o pausar",
inProgressRework: "Reenviar la finalización",
paused: "Reanudar o reprogramar",
completed: "Verificar o solicitar repetición",
},
verifyCompletion: {
title: "Dar conformidad al trabajo",
message: "¿Dar conformidad a esta orden de trabajo? Se notificará al responsable.",
confirm: "Dar conformidad",
},
video: {
unsupportedSource: "No se puede reproducir este video desde esta ubicación.",
loadFailed: "No se pudo cargar el video.",
},
notScheduled: "Sin programar",
openInspectionA11y: "Abrir inspección {{label}}",
media: {
closeImageViewer: "Cerrar el visor de imágenes",
closeVideoViewer: "Cerrar el reproductor de vídeo",
},
kpi: {
overdueLabel: "Vencidas",
overdueSub: "Requiere acción inmediata",
inProgressLabel: "En curso",
inProgressSub: "En ejecución actualmente",
dueSoonLabel: "Vencen pronto",
dueSoonSub: "Próximas 72 horas",
},
command: {
openCalendar: "Abrir calendario",
createJob: "Crear orden de trabajo",
refine: "Refinar",
clearFilters: "Borrar filtros",
exportCsv: "Exportar CSV",
},
exportCsvHeaders: {
title: "Título",
status: "Estado",
asset: "Activo",
priority: "Prioridad",
assignee: "Responsable",
updated: "Actualizado",
},
inspector: {
openJob: "Abrir orden de trabajo",
addUpdate: "Añadir actualización",
accept: "Aceptar",
reject: "Rechazar",
assign: "Asignar",
schedule: "Programar",
start: "Iniciar",
pause: "Pausar",
resume: "Reanudar",
complete: "Completar",
approve_rework: "Aprobar repetición",
verify: "Verificar",
rework: "Solicitar repetición",
},
workQueueHeading: "Cola de trabajo",
queueEmpty: "No hay órdenes de trabajo en esta cola.",
emptyMatchingWebTitle: "Sin órdenes de trabajo coincidentes",
emptyMatchingWebSub: "Pruebe otra cola o borre los filtros.",
emptyBucketTitle: "Sin órdenes de trabajo en {{bucket}}",
emptyBucketSub: "Cambie a Requiere acción, Planificada o Historial, o borre los filtros para ampliar los resultados.",
goToNeedsAction: "Ir a Requiere acción",
goToNeedsActionA11y: "Mostrar órdenes de trabajo en Requiere acción",
clearJobFiltersA11y: "Borrar los filtros de órdenes de trabajo",
panelHeading: "Detalles de la orden de trabajo",
emptyScopeTitle: "Sin órdenes de trabajo en el ámbito",
emptyScopeSub: "Ajuste los filtros, la cola o el ámbito del equipo para cargar órdenes de trabajo.",
sectionOverview: "Resumen",
sectionActivity: "Actividad",
noActivityYet: "Aún no hay actividad.",
loading: "Cargando órdenes de trabajo…",
emptyNoJobsYet: "Aún no hay órdenes de trabajo",
emptyRecipientSub: "Las órdenes de trabajo de las inspecciones compartidas con usted aparecerán aquí cuando el inspector las cree a partir de reparaciones aprobadas.",
emptyOwnerSub: "Cree una orden de trabajo directamente o convierta reparaciones aprobadas de una inspección compartida.",
viewActivity: "Ver actividad",
canonicalStatus: {
  skipped: "Omitido",
draft: "Borrador",
open: "Abierta",
accepted: "Aceptada",
scheduled: "Programada",
in_progress: "En curso",
paused: "En pausa",
completed: "Completada",
verified: "Conforme",
rejected: "Rechazada",
cancelled: "Cancelada",
},
fabCreateA11y: "Crear orden de trabajo",
detailWorkPath: {
change: "Cambiar vía de trabajo",
sheetTitle: "Vía de trabajo",
sheetHint: "Elija cómo se realizará esta orden de trabajo: equipo interno, un contratista o solicitar presupuestos.",
team: "Equipo",
contractor: "Contratista",
quotes: "Presupuestos",
},
advancedFiltersSummary_many: "{{count}} filtros activos",
},
inspectionDetail: {
firstRunMomentumHint: "Responde cada elemento con Aprobado, Fallido o No aplica. Toca Seguimiento en lo que necesite una orden de trabajo.",
firstRunGotIt: "Entendido",
firstRunReportCta: "Notificar un problema",
reportIssueNow: "Notificar un problema ahora",
completeInspection: "Completar inspección",
completeShort: "Completar",
continueInspection: "Continuar inspección",
continueShort: "Continuar",
manage: "Gestionar",
manageSheetTitle: "Acciones de la inspección",
reassign: "Reasignar",
pause: "Pausar",
cancel: "Cancelar la inspección…",
viewReport: "Ver informe",
nextSteps: "Próximos pasos",
share: "Compartir",
createJobs: "Crear órdenes de trabajo",
sendForApproval: "Enviar para aprobación",
shareReport: "Compartir informe",
planFollowUp: "Planificar seguimiento",
planFollowUpHint: "Pasos opcionales después de finalizar esta inspección.",
saveTemplate: "Guardar lista de control",
repeatOnSchedule: "Repetir según programación",
createJobNow: "Crear orden de trabajo ahora",
notifyTeam: "Notificar al equipo",
moreMenuA11y: "Más acciones de la inspección",
},
assetDetail: {
  shareChooser: {
    intakeDescription: "Sin cuenta ni inicio de sesión. Cada aviso llega a Trabajo como solicitud, lista para planificar una inspección o una orden de trabajo.",
    intakeTitle: "Permitir que cualquiera con el código informe de un problema",
    personDescription: "Verán este activo, sus inspecciones y documentos. Elige Puede solicitar trabajo en el siguiente paso si también deben informar de problemas.",
    personTitle: "Compartir con una persona o un equipo",
  },
  publicIntakeCard: {
    turnOff: "Desactivar",
    keepOn: "Mantener activado",
    turnOffBody: "Los códigos impresos y los enlaces compartidos dejan de funcionar hasta que lo vuelvas a activar.",
    turnOffTitle: "¿Desactivar los avisos?",
    copyFailedBody: "Inténtalo de nuevo. También puedes hacer una captura del código y compartirla.",
    copyFailedTitle: "No se pudo copiar el enlace",
    linkCopied: "Enlace copiado. Pégalo donde la gente deba informar de problemas.",
    tryAgain: "Comprueba tu conexión e inténtalo de nuevo.",
    updateFailedTitle: "No se cambiaron los avisos",
    turnedOff: "Los avisos están desactivados. El código y el enlace ya no aceptan avisos.",
    turnedOn: "Los avisos están activados. Imprime el código o copia el enlace y ponlo donde la gente lo vea.",
    printBody: "Escanea para informar de un problema. No necesitas cuenta ni iniciar sesión.",
    printTitle: "Informar de un problema — {{name}}",
    popupBlockedBody: "Permite las ventanas emergentes en este sitio para imprimir, o usa Copiar enlace.",
    popupBlockedTitle: "Ventana emergente bloqueada",
    noWebAddress: "Los avisos están activados, pero esta versión de la app no puede crear el enlace. Abre este activo en AssetWRX desde un navegador para copiar el enlace o imprimir el código.",
    copyLinkA11y: "Copiar el enlace para informar de un problema",
    step3: "3. Describen el problema. Aparece en Trabajo como una solicitud para que la revises.",
    qrLabel: "Código para informar de un problema",
    title: "Permitir que cualquiera informe de un problema",
  },
overviewInspectionEmpty: "Aún no hay inspecciones. Use",
startInspection: "Iniciar inspección",
createJob: "Crear orden de trabajo",
edit: "Editar",
contactsSectionTitle: "Contactos vinculados",
viewActivity: "Ver actividad",
toolsAi: "Herramientas e IA",
generateAdvancedReport: "Asset 360",
askAi: "Preguntar a la IA",
suggestNextSteps: "Sugerir próximos pasos",
shareThisAssetModalTitle: "Compartir este activo",
shareThisAssetAccessOnlySubtitle: "Da acceso a una persona o equipo al registro, las inspecciones y los documentos de este activo.",
shareWithPersonAccessOnlyDescription: "Ven el registro, las inspecciones y los documentos de este activo.",
linkContactModalTitle: "Vincular contacto",
shareWithContactCallout: "Compartir este activo con {{name}}",
journey: {
title: "Recorrido operativo",
stage: {
created: "Creado",
inspected: "Inspecciones completadas",
issues: "Problemas registrados",
requests: "Solicitudes creadas",
jobs: "Órdenes de trabajo completadas",
reports: "Informes generados",
},
window: {
"30d": "30d",
"90d": "90d",
"365d": "1 año",
all: "Todo",
},
windowLabel: {
"30d": "En los últimos 30 días",
"90d": "En los últimos 90 días",
"365d": "En los últimos 12 meses",
all: "En todo el historial de este activo",
},
readOnlyHint: "Tiene acceso de solo lectura al recorrido de este activo.",
a11ySummaryLabel: "Resumen del recorrido operativo",
a11yStageHint: "{{label}}: {{count}} en el periodo",
a11yStageSubline: "{{label}}: {{count}} en el periodo, {{subline}}",
zeroInWindow: "0 en {{window}}",
dateUnavailable: "Fecha no disponible",
ago: {
minutes: "hace {{n}} min",
hours: "hace {{n}} h",
days: "hace {{n}} d",
months_one: "hace {{count}} mes",
months_many: "hace {{count}} meses",
months_other: "hace {{count}} meses",
years_one: "hace {{count}} año",
years_many: "hace {{count}} años",
years_other: "hace {{count}} años",
},
in: {
minutes: "en {{n}} min",
hours: "en {{n}} h",
days: "en {{n}} d",
},
sublineIssueBreach: "{{days}}+ d sin solicitud",
sublineAwaitingApproval_one: "{{count}} pendiente de aprobación",
sublineAwaitingApproval_many: "{{count}} pendientes de aprobación",
sublineAwaitingApproval_other: "{{count}} pendientes de aprobación",
summary: {
noActivity: "{{window}}, este activo no tiene actividad registrada.",
recommendBaseline: "Se recomienda programar una inspección de referencia.",
hadBoth: "{{window}}, este activo ha tenido {{inspections}} y {{jobs}}.",
hadOne: "{{window}}, este activo ha tenido {{what}}.",
hadNone: "{{window}}, este activo aún no tiene trabajo completado.",
inspections_one: "{{count}} inspección",
inspections_many: "{{count}} inspecciones",
inspections_other: "{{count}} inspecciones",
jobsCompleted_one: "{{count}} trabajo completado",
jobsCompleted_many: "{{count}} trabajos completados",
jobsCompleted_other: "{{count}} trabajos completados",
healthImproved: "La salud operativa mejoró de {{then}}/100 a {{now}}/100.",
healthDeclined: "La salud operativa bajó de {{then}}/100 a {{now}}/100.",
healthCurrent: "La salud operativa actual es {{now}}/100, según el cumplimiento, las programaciones, los trabajos, las aprobaciones y los hallazgos de inspección.",
conditionUnscored_one: "El estado de inspección no está valorado: {{count}} inspección completada no tiene una valoración válida de 1 a 5.",
conditionUnscored_many: "El estado de inspección no está valorado: ninguna de las {{count}} inspecciones completadas tiene una valoración válida de 1 a 5.",
conditionUnscored_other: "El estado de inspección no está valorado: ninguna de las {{count}} inspecciones completadas tiene una valoración válida de 1 a 5.",
conditionOneRated: "El estado de inspección tiene una inspección valorada; hace falta otra para mostrar una tendencia.",
issueOverdue: "Una incidencia abierta lleva demasiado tiempo sin solicitud.",
requestsAwaiting_one: "Una solicitud está pendiente de aprobación.",
requestsAwaiting_many: "{{count}} solicitudes están pendientes de aprobación.",
requestsAwaiting_other: "{{count}} solicitudes están pendientes de aprobación.",
excluded_one: "Se excluyó {{count}} inspección completada: {{reasons}}.",
excluded_many: "Se excluyeron {{count}} inspecciones completadas: {{reasons}}.",
excluded_other: "Se excluyeron {{count}} inspecciones completadas: {{reasons}}.",
excludedMissing: "{{n}} sin fecha de finalización",
excludedInvalid: "{{n}} con una fecha de finalización no válida",
excludedFuture: "{{n}} con fecha futura",
},
},
},
quickComplete: {
moreOptions: "Asistente de finalización avanzada",
moreOptionsA11y: "Abrir el asistente de finalización avanzada",
eyebrow: "Cierre rápido",
needsMore: {
  invoice: "Este trabajo también necesita sus costes y factura. Continuar los añade y luego lo completa.",
  meter: "Este trabajo también necesita una lectura del contador. Continuar la pide y luego lo completa.",
  checks: "Hay algo que resolver antes de completar este trabajo. Continuar muestra qué.",
},
onePageTitle: "Completar el trabajo",
continue: "Continuar",
submit: "Completar orden de trabajo",
step1: {
title: "Nota rápida",
noteLabel: "¿Qué hizo?",
notePlaceholder: "Una línea — reparado, sustituido, inspeccionado, limpiado.",
noteA11y: "Nota de cierre rápido",
dictateStart: "Dictar",
dictateStop: "Detener dictado",
chipsLabel: "O toca una etiqueta rápida",
},
step2: {
title: "Añadir evidencia",
summary: "Haz una foto o adjunta un documento. Opcional, pero recomendado.",
unavailable: "Las evidencias en línea no están disponibles aquí.",
},
step3: {
title: "Enviar",
summary: "Confirma y completa.",
note: "Nota",
noNote: "Sin nota añadida",
tags: "Etiquetas",
evidence: "Evidencia",
outcome: "Resultado",
},
},
changeRequest: {
comeBack: {
  title: "Necesito volver",
  hint: "Otra visita otro día. El trabajo sigue abierto y se completa una sola vez, al final.",
},
open: "No se puede completar según lo programado",
openA11y: "Notificar que no puede completar esto según lo programado",
eyebrow: "Cambio solicitado",
step1: {
title: "¿Qué se lo impidió?",
summary: "Elija el motivo más parecido. Determina quién debe saberlo.",
},
step2: {
  datePlaceholder: "Elegir un día",
title: "¿Qué necesita?",
summary: "Su responsable decide. Nada cambia hasta que lo haga.",
summaryImmediate: "Omitir se aplica de inmediato en este plan. El resto pasa a su responsable.",
dateLabel: "Trasladar a",
assigneeLabel: "Sugerir a alguien",
assigneeHint: "Una sugerencia — su responsable puede elegir a otra persona.",
},
step3: {
title: "¿Algo más?",
noteLabel: "Añadir detalle",
notePlaceholder: "Qué vio, con quién habló, qué lo desbloquearía.",
evidencePrompt: "Una foto facilita mucho la aprobación.",
submit: "Enviar solicitud",
submitImmediate: "Omitir esta",
submitting: "Enviando…",
},
reason: {
no_access: "Sin acceso",
asset_unavailable: "Activo no disponible",
asset_in_use: "Activo en uso",
unsafe: "No es seguro continuar",
parts_unavailable: "Piezas no disponibles",
time_insufficient: "Tiempo insuficiente",
meter_inaccessible: "No se puede acceder al contador",
specialist_required: "Se requiere un especialista",
wrong_assignee: "Debería ser otra persona",
done_elsewhere: "Ya realizado en otro lugar",
not_required: "No es necesario",
bigger_than_described: "Más grande de lo descrito",
other: "Otro motivo",
},
action: {
reschedule: "Trasladarlo",
rescheduleBlurb: "Mismo trabajo, misma persona, una fecha posterior.",
rescope: "Necesita más de lo descrito",
rescopeBlurb: "El mismo trabajo, la misma persona, pero mayor de lo descrito. Di cuánto necesita realmente.",
rescopeLength: "¿Cuánto necesita realmente? (minutos)",
reassign: "Otra persona",
reassignBlurb: "Mismo trabajo, sigue pendiente, otra persona.",
skip: "Omitir esta",
skipBlurb: "Esta visita no se hará. La siguiente sigue pendiente.",
},
status: {
  waitingOnApprover: "Esperando a que decida el aprobador del activo. Recibirá una notificación.",
pending: "Cambio solicitado",
waitingOn: "Esperando a que {{name}} decida. Recibirá una notificación.",
approved: "Cambio aprobado",
rejected: "Cambio no aprobado",
stillDue: "Este trabajo sigue pendiente",
},
review: {
  closeStale: "Cerrar solicitud",
  changedSinceDecide: "Este trabajo cambió después de enviar la solicitud, así que ya no se puede aprobar. Ciérrela con una nota; podrán volver a pedirlo si aún lo necesitan.",
title: "Revisar solicitud",
requestedBy: "Solicitado por {{name}}",
asked: "Solicitó",
reason: "Motivo",
evidence: "Evidencia",
current: "Actualmente",
proposed: "Propuesto",
changedSince: "Este trabajo cambió desde que se creó la solicitud.",
approve: "Aprobar",
reject: "Rechazar",
editAndApprove: "Cambiar y aprobar",
rejectNeedsNote: "Indica el motivo antes de rechazar",
changeDate: "Aprobar otra fecha",
changeAssignee: "Aprobar a otra persona",
note: "Añadir una nota",
complianceWarning: "Este activo tiene una obligación de cumplimiento.",
},
},
completeWizard: {
needs: {
  title: "Comprobaciones y evidencias",
  summary: "Marque la lista de verificación y añada las fotos. Las fotos se comprueban automáticamente con la orden de trabajo.",
},
eyebrow: "Completar orden de trabajo",
addCosts: "Añadir costes y factura",
submit: "Enviar finalización",
step1: {
title: "Notas",
noteLabel: "¿Qué hizo?",
notePlaceholder: "Resumen breve — qué reparó, sustituyó o inspeccionó.",
noteA11y: "Nota de finalización",
chipsLabel: "Etiquetas rápidas",
dictate: "Dictar",
dictateStart: "Dictar",
dictateStop: "Detener dictado",
improve: "Mejorar con IA",
improving: "Mejorando…",
},
step2: {
title: "Evidencia",
summary: "Añada pruebas del trabajo. Fotos, documentos o una factura si es necesario.",
addPhoto: "Añadir foto",
addDocument: "Añadir documento",
addInvoice: "Añadir factura",
count_one: "{{count}} elemento adjunto",
count_other: "{{count}} elementos adjuntos",
empty: "Aún no hay evidencia adjunta.",
count_many: "{{count}} elementos adjuntos",
analyze: "Leer las fotos",
addToNote: "Añadir el texto extraído a la nota",
},
step3: {
title: "Costes y factura",
summary: "Registra lo que costó esta orden de trabajo. Añade una factura o un recibo si lo tienes.",
summaryInvoice: "Registra lo que costó esta orden de trabajo y adjunta una factura. Este cliente la exige.",
empty: "No hay editor de costes disponible aquí. Usa la vista de gestión para registrar los costes.",
},
step4: {
title: "Resultado",
summary: "¿Cómo terminó esta orden de trabajo?",
followUpHint: "Le ofreceremos crear una orden de trabajo de seguimiento tras el envío.",
},
step5: {
title: "Revisar y enviar",
summary: "Confirme lo que se va a enviar.",
note: "Nota",
noNote: "Sin nota añadida",
tags: "Etiquetas",
evidence: "Evidencia",
outcome: "Resultado",
cost: "Coste",
noCost: "No registrado",
invoice: "Factura",
invoiceNone: "Ninguna",
evidenceNone: "Ninguna",
blockersTitle: "Corrija antes de enviar:",
invoiceAttached: "{{n}} adjunta(s)",
invoiceRequiredMissing: "Obligatoria — ninguna adjunta",
invoiceRequiredBlocker: "Este cliente exige una factura. Adjunta una en Costes y factura, o genérala allí.",
},
chips: {
fixed: "Reparado",
replaced: "Sustituido",
inspected: "Inspeccionado",
cleaned: "Limpiado",
needsFollowUp: "Requiere seguimiento",
unableToComplete: "No se pudo completar",
},
outcomes: {
completed: "Completado",
partial: "Completado parcialmente",
followUp: "Requiere seguimiento",
unable: "No se pudo completar",
},
step0: {
title: "Revisión posterior",
done: "Todas las comprobaciones están completas. Continúa para cerrar la orden de trabajo.",
summary: "Responde a cada paso de la comprobación posterior. La orden de trabajo no se puede enviar hasta que esté terminada.",
},
},
jobMode: {
switcher: {
enterFocus: "Modo enfoque",
exitFocus: "Vista completa",
a11yEnterFocus: "Centrarse en ejecutar el trabajo: ocultar los detalles de gestión",
a11yExitFocus: "Mostrar la orden de trabajo completa",
},
report: {
open: "Abrir informe de finalización",
title: "Informe de cierre",
fallbackTitle: "Orden de trabajo",
missingJob: "Orden de trabajo no encontrada.",
followOn: "Trabajo de seguimiento",
shareTitle: "Compartir informe de cierre",
shareAction: "Compartir",
shareReviewLink: "Compartir enlace de revisión",
shareSheetTitle: "Compartir informe",
summaryEyebrow: "Resumen de cierre",
notesEyebrow: "Notas de cierre",
noNotes: "—",
checksEyebrow: "Comprobaciones previas y posteriores",
evidenceEyebrow: "Evidencias y adjuntos",
recentExports: "Exportaciones recientes",
optionsTitle: "Opciones de informe",
fields: {
job: "Orden de trabajo",
jobType: "Tipo de orden de trabajo",
parentJob: "Orden de trabajo principal",
asset: "Activo",
location: "Ubicación",
assignedTo: "Asignado a",
status: "Estado",
submitted: "Enviada",
verified: "Verificada",
completed: "Completado",
actualCost: "Costo real",
},
},
},
maintenance: {
  steps: {
    keep: "Mantener los pasos",
    close: "Cerrar",
    failed: "No se pudieron guardar los pasos",
    unlinked: "Pasos desvinculados. Cada uno vuelve a ser un plan propio.",
    unlinkConfirm: "Desvincular",
    unlinkMessage: "Cada paso vuelve a ser un plan propio y conserva su calendario. No se elimina nada.",
    unlinkTitle: "¿Desvincular estos pasos?",
    unlink: "Desvincular pasos",
    saved: "Pasos guardados.",
    save: "Guardar pasos",
    inOrderOff: "Cada paso llega según su propio calendario.",
    inOrderOn: "El trabajo de un paso solo se crea cuando el paso anterior no tiene trabajo abierto.",
    inOrderTitle: "Hacer los pasos en orden",
    moveDownA11y: "Bajar {{name}}",
    moveUpA11y: "Subir {{name}}",
    removeA11y: "Quitar {{name}} de los pasos",
    addA11y: "Añadir {{name}} como paso",
    add: "Añadir",
    inOtherSet: "Ahora es un paso de {{name}}",
    otherLabel: "Otros planes de este activo",
    needTwo: "Añada al menos dos planes de la lista de abajo.",
    stepsLabel: "Pasos, en orden",
    namePlaceholder: "Por ejemplo: Servicios del generador",
    nameLabel: "Nombre",
    intro: "Los pasos son planes que van juntos, como un servicio a las 500, 1.000 y 2.000 horas.",
    titleEdit: "Editar pasos",
    titleNew: "Vincular planes como pasos",
    addStep: "Añadir un paso",
    editSteps: "Editar pasos",
    linkSteps: "Vincular planes como pasos",
  },
  list: {
    status: {
      cancelled: "Cancelado",
      ended: "Finalizado",
      paused: "En pausa",
      active: "Activo",
    },
    openJobA11y: "Abrir la orden de trabajo actual de {{name}}",
    editA11y: "Editar {{name}}",
    untitled: "Plan sin título",
    groupA11y: "{{asset}}: {{n}} planes. Abre el activo.",
    emptyBody: "Añada un plan para un trabajo que se repite: un servicio mensual, una prueba anual. Cada vez que vence, la orden de trabajo aparece en Trabajo.",
    tryAgain: "Reintentar",
    loadFailed: "No se pudieron cargar los planes de mantenimiento. Compruebe la conexión e inténtelo de nuevo.",
    activeMany: "{{live}} planes en marcha",
    activeOne: "1 plan en marcha",
    noneActive: "No hay ningún plan en marcha. Reanude uno o añada uno nuevo.",
    dueInDays: "Próximo en {{days}} días",
    dueTomorrow: "Próximo mañana",
    dueToday: "Próximo hoy",
    overdueDays: "Atrasado {{days}} días",
    overdueOneDay: "Atrasado 1 día",
    doneCount: "{{done}} generados",
    doneOfMax: "{{done}} de {{max}} generados",
  },
  cadence: {
    fromLastDone: "{{cadence}}, contando desde que se termina el anterior",
    oneOff: "Puntual",
    either: "{{first}} o {{second}}, lo que llegue antes",
    everyAmount: "Cada {{amount}}",
    everyNYears_one: "Cada {{count}} año",
    everyNYears_many: "Cada {{count}} años",
    everyNYears_other: "Cada {{count}} años",
    everyYear: "Cada año",
    everyNMonths_one: "Cada {{count}} mes",
    everyNMonths_many: "Cada {{count}} meses",
    everyNMonths_other: "Cada {{count}} meses",
    everyMonth: "Cada mes",
    everyNWeeks_one: "Cada {{count}} semana",
    everyNWeeks_many: "Cada {{count}} semanas",
    everyNWeeks_other: "Cada {{count}} semanas",
    everyWeek: "Cada semana",
    everyNDays_one: "Cada {{count}} día",
    everyNDays_many: "Cada {{count}} días",
    everyNDays_other: "Cada {{count}} días",
    everyDay: "Cada día",
    everyNHours_one: "Cada {{count}} hora",
    everyNHours_many: "Cada {{count}} horas",
    everyNHours_other: "Cada {{count}} horas",
    everyHour: "Cada hora",
  },
title: "Mantenimiento",
recordReading: "Registrar lectura",
addPlan: "Añadir plan",
startNow: "Iniciar ahora",
exceptions: {
lead: "La mayoría de las omisiones son \"{{reason}}\" — el {{share}}% de ellas.",
counts: "{{skipped}} omitidas · {{missed}} no realizadas",
emptyDimension: "Aún no hay nada registrado para esto — pruebe otro desglose.",
noSite: "Sin sitio",
unassigned: "Sin asignar",
by: {
reason: "Motivo",
asset: "Activo",
site: "Sitio",
assignee: "Responsable",
programme: "Plan",
team: "Equipo",
},
},
card: {
  ok: "Aceptar",
  actionFailedBody: "No se ha cambiado nada. Compruebe la conexión e inténtelo de nuevo.",
  allPlans: "Todos los planes",
heading: "Planes de mantenimiento",
attention_one: "{{count}} plan requiere atención",
attention_other: "{{count}} planes requieren atención",
allOnTrack: "Todos los planes van según lo previsto",
pausedCount_one: "{{count}} plan en pausa",
pausedCount_many: "{{count}} planes en pausa",
pausedCount_other: "{{count}} planes en pausa",
nextUp: "Próximo: {{what}}",
showAll: "Mostrar los {{count}} planes",
showFewer: "Mostrar menos",
expandHint: "Muestra lo que se aproxima y las acciones del plan",
status: {
job_overdue: "Orden de trabajo abierta · vencida",
overdue: "Vencido",
job_due: "Orden de trabajo abierta · vence ahora",
due: "Vence ahora",
no_reading: "Requiere una lectura",
due_soon: "Vence pronto",
due_soon_days_one: "Vence mañana",
due_soon_days_other: "Vence en {{count}} días",
due_soon_amount: "Vence en {{amount}}",
job: "Orden de trabajo abierta",
waits: "Espera a {{stage}}",
waits_generic: "Espera al paso anterior",
afterStep: "Después del paso {{n}}",
skipped: "Omitido esta vez",
upcoming_date: "Próxima {{when}}",
upcoming_time: "Próxima a las {{time}}",
upcoming_meter: "Próxima en {{amount}}",
upcoming_none: "Se ejecuta al iniciarse",
upcoming_condition: "Vigilando el estado",
paused: "En pausa",
due_soon_days_many: "Vence en {{count}} días",
},
cadence: {
manual: "Cuando alguien la inicia",
fixedDate: "Una vez, el {{when}}",
fixedDates_one: "En {{count}} fecha fija",
fixedDates_many: "En {{count}} fechas fijas",
fixedDates_other: "En {{count}} fechas fijas",
condition: "Cuando su estado baja a {{score}} o menos",
renewal: "Cuando su documento vence para renovación",
byMeter: {
operating_hours: "Por horas de la máquina",
mileage: "Por kilometraje",
cycles: "Por ciclos",
custom_numeric: "Por lectura del contador",
electricity: "Por contador de electricidad",
gas: "Por contador de gas",
water: "Por contador de agua",
heat: "Por contador de calor",
oil: "Por contador de gasóleo",
},
},
comingUp: "Próximamente",
lastDone: "Última realizada",
notDoneYet: "Aún no realizada",
perDay: "{{count}} al día a partir de entonces",
jobOpen: "Orden de trabajo abierta",
either: "{{amount}} o {{when}}, lo que ocurra primero",
nothingNext: "No hay nada programado. Se ejecuta cuando alguien la inicia.",
nothingNextCondition: "Se genera trabajo cuando la puntuación de estado baja hasta ese punto.",
pausedNext: "No se genera nada mientras el plan está en pausa.",
steps_sequential_one: "{{count}} paso, realizado en orden",
steps_sequential_many: "{{count}} pasos, realizados en orden",
steps_sequential_other: "{{count}} pasos, realizados en orden",
steps_independent_one: "{{count}} plan en este grupo",
steps_independent_many: "{{count}} planes en este grupo",
steps_independent_other: "{{count}} planes en este grupo",
step: "Paso {{n}}",
openJob: "Abrir la orden de trabajo",
startNow: "Iniciar ahora",
edit: "Editar",
bringForward: "Adelantar",
endStep: "Terminar paso",
pause: "Pausar",
resume: "Reanudar",
end: "Finalizar plan",
endTitle: "¿Finalizar este plan?",
endMessage: "No se creará trabajo nuevo. El trabajo ya generado permanece en Trabajo, y su historial permanece en el activo.",
keep: "Conservar plan",
actionFailed: "No se pudo cambiar el plan",
attention_many: "{{count}} planes requieren atención",
},
startFailedTitle: "No se pudo iniciar",
noReading: "Aún no hay lectura del contador.",
noPlans: "Aún no hay plan de mantenimiento.",
plansHeading: "Planes · {{n}}",
plansHeadingNone: "Planes",
meters: {
heading: "Contadores · {{n}}",
since: "{{amount}} desde {{when}}",
record: "Registrar una lectura",
},
emptyReadingTitle: "Sin lectura registrada",
emptyReadingBody: "Los planes que cuentan por uso necesitan una lectura de referencia.",
emptyPlansTitle: "Aún no hay planes",
emptyPlansBody: "Pulse Añadir plan para un trabajo que se repite: un servicio, una prueba o una inspección. Cada uno aparece en Trabajo cuando vence.",
kind: {
mileage: "Kilometraje",
operating_hours: "Horas",
cycles: "Ciclos",
electricity: "Electricidad",
gas: "Gas natural",
water: "Agua",
heat: "Calor",
oil: "Gasóleo",
custom_numeric: "Otro",
},
unit: {
mi: "mi",
km: "km",
h: "h",
cycles: "ciclos",
},
source: {
manual: "introducida",
local_ml: "desde foto",
imported: "importada",
api: "API",
iot: "sensor",
},
sync: {
pending: "Guardado en este dispositivo — se sincronizará al conectarse.",
failed: "No se pudo guardar — ya se registró antes una lectura más alta.",
},
rowTitle: {
due_soon_meter: "{{title}} vence en {{amount}}",
due_meter: "{{title}} vence ahora",
overdue_meter: "{{title}} vencido por {{amount}}",
due_soon_calendar: "{{title}} vence pronto",
due_calendar: "{{title}} vence hoy",
overdue_calendar: "{{title}} vencido",
},
sheet: {
  typeReading: "Escriba la lectura. La foto se guarda como prueba; la aplicación del teléfono puede leer el número.",
  kind: "Contador",
  noMeterId: "Sin ID de contador",
  newMeter: "Contador nuevo",
  meterId: "ID del contador (opcional)",
  meterIdPlaceholder: "Número de serie o de suministro",
  unit: "Unidad",
title: "Registrar una lectura del contador",
close: "Cerrar",
value: "Lectura",
when: "Tomada",
whenInvalid: "Elija una fecha y hora válidas.",
currentIs: "Actual: {{amount}} · {{when}}",
reading: "Leyendo la foto en este dispositivo…",
detected: "Lectura del contador detectada: {{amount}}",
trust: {
confirm: "Confirmar · leído en este dispositivo, sin usar créditos de IA",
check: "Compruebe esto · leído en este dispositivo, sin usar créditos de IA",
},
use: "Usar",
ignore: "Ignorar",
nothingDetected: "No se encontró ninguna lectura en la foto — escríbala. La foto se conserva como evidencia.",
lower: "Esto es menor que el valor actual de {{amount}}.",
outOfOrder: "Ya hay registrada una lectura de {{amount}} después de esta fecha. Compruebe cuándo se tomó esta.",
lowerAsk: "¿Registrarla como corrección? La lectura anterior permanece en el historial, pero deja de contar.",
lowerHint: "Compruebe el número, o pida a un responsable que registre una corrección.",
correctionNote: "¿Por qué es incorrecta la lectura anterior?",
correctionNoteRequired: "Indique por qué era incorrecta la lectura anterior.",
unitMismatch: "Este contador mide en {{unit}}.",
save: "Guardar lectura",
saveCorrection: "Guardar como corrección",
saving: "Guardando…",
failed: "No se pudo guardar la lectura.",
savedOfflineTitle: "Guardado en este dispositivo",
savedOffline: "Se sincronizará cuando vuelva a estar conectado.",
recent: "Lecturas recientes",
correctionTag: "corrección",
},
},
contractor: {
title: "Mi trabajo",
view: {
new: "Nuevo",
upcoming: "Pendiente",
in_progress: "En curso",
awaiting_review: "En espera",
complete: "Hecho",
},
empty: {
new: "No hay solicitudes nuevas",
upcoming: "Nada programado",
in_progress: "Nada en curso",
awaiting_review: "Nada con el cliente",
complete: "Todavía no hay nada completado",
},
emptyHint: {
new: "Aquí verá las invitaciones y las peticiones de presupuesto.",
upcoming: "Los trabajos que acepte aparecerán aquí.",
in_progress: "Inicie un trabajo desde Próximos cuando llegue.",
awaiting_review: "Lo que envíe espera aquí a que el cliente lo apruebe.",
complete: "Aquí aparecerá el trabajo que el cliente haya aprobado.",
},
quoteFallbackTitle: "Solicitud de presupuesto",
clientOther: "Otros",
next: {
quote: "Envía un precio o rechaza",
waitingClient: "Esperando al cliente",
},
notLinked: {
title: "Aún no estás dado de alta como contratista",
body: "Pide a tu cliente que te añada con el correo con el que te registraste y su trabajo aparecerá aquí.",
bodyWithEmail: "Pide a tu cliente que te añada como contratista con {{email}}. Sus trabajos y solicitudes de presupuesto aparecerán aquí.",
checkAgain: "Comprobar de nuevo",
checking: "Comprobando…",
},
loadFailed: {
title: "Tu trabajo no se ha cargado",
body: "Comprueba tu conexión y toca Reintentar.",
retry: "Reintentar",
},
},
planning: {
  lockedHint: "Asigne visitas a personas y horas, vea los desplazamientos y obtenga un plan sugerido para el día.",
  leave: {
    message_other: "Tiene {{count}} cambios del plan sin guardar todavía. Descártelos, o siga planificando y pulse Aplicar.",
    message_many: "Tiene {{count}} cambios del plan sin guardar todavía. Descártelos, o siga planificando y pulse Aplicar.",
    message_one: "Tiene {{count}} cambio del plan sin guardar todavía. Descártelo, o siga planificando y pulse Aplicar.",
    discard: "Descartar cambios",
    keep: "Seguir planificando",
    title: "¿Salir sin guardar el plan?",
  },
range: {
day: "Día",
threeDay: "3 días",
week: "Semana",
month: "Mes",
agenda: "2 semanas",
a11y: "Intervalo del calendario",
},
nav: {
previousA11y: "Antes",
nextA11y: "Después",
today: "Hoy",
todayA11y: "Ir a hoy",
},
lane: {
unassigned: "Sin asignar",
you: "Usted",
unnamed: "Persona sin nombre",
notWorking: "No trabaja",
timeOff: "Ausente",
more: "+{{count}} más",
moreA11y: "Mostrar {{count}} más a las {{time}}",
showLess: "Mostrar menos",
load: "{{percent}} % planificado · {{work}}",
capacityA11y: "{{name}}: el {{percent}} % del día está planificado",
},
summary: {
jobs_one: "{{count}} visita",
jobs_many: "{{count}} visitas",
jobs_other: "{{count}} visitas",
work: "{{duration}} de trabajo",
travel: "{{duration}} de desplazamiento",
travelEstimated: "unos {{duration}} de desplazamiento",
travelUnknown_one: "{{count}} trayecto sin ubicación",
travelUnknown_many: "{{count}} trayectos sin ubicación",
travelUnknown_other: "{{count}} trayectos sin ubicación",
free: "{{duration}} libres",
overtime: "{{duration}} de horas extra",
},
readiness: {
ready: "Listos {{count}}",
parts: "Faltan piezas {{count}}",
capacity: "Nadie libre o capacitado {{count}}",
other: "En espera {{count}}",
defer: "Pueden esperar {{count}}",
},
unplanned: {
nobody: "Tiene hora, pero nadie asignado",
title: "Sin planificar · {{count}}",
empty: "Todo lo que se ve está planificado.",
filterDue: "Vencen",
filterAll: "Todos",
filterA11y: "Qué trabajo sin planificar mostrar",
due: "Vence {{date}}",
overdue: "Vencido",
},
reason: {
parts_unavailable: "Pieza no disponible",
technician_unavailable: "Nadie disponible",
skill_missing: "Cualificación no disponible",
dependency: "A la espera de otro trabajo",
no_capacity: "Sin capacidad",
location_missing: "Sin ubicación",
appointment_conflict: "No se puede cumplir la cita",
outside_hours: "Fuera del horario laboral",
awaiting_approval: "A la espera de aprobación",
declined: "Rechazado",
crew_unavailable: "No hay suficientes personas libres a la vez",
},
signal: {
overlap: "Reserva duplicada",
insufficient_travel: "Tiempo de desplazamiento insuficiente",
skill_missing: "Falta cualificación",
parts_unavailable: "Pieza no disponible",
outside_appointment: "Fuera de la cita",
outside_hours: "Fuera del horario laboral",
technician_unavailable: "Ausente",
dependency_unmet: "A la espera de otro trabajo",
after_due: "Después de la fecha límite",
urgent: "Prioridad alta",
parts_ready: "Piezas listas",
parts_unknown: "Piezas sin confirmar",
appointment: "Franja de cita",
awaiting_acceptance: "A la espera de aceptación",
confirmed: "Confirmado",
locked: "Hora fijada",
duration_default: "Duración estimada",
duration_learned: "Duración habitual",
multi_day: "Dura varios días",
crew_visit: "Como parte del equipo",
via_pickup: "Recogida de pieza en el camino",
},
state: {
pending: "Sugerido",
in_progress: "En curso",
done: "Hecho",
},
travel: {
block: "{{duration}} de desplazamiento · {{distance}}",
estimated: "unos {{duration}} de desplazamiento · {{distance}}",
a11y: "Desplazamiento: {{duration}}",
estimateNote: "El desplazamiento se estima a partir de la distancia en línea recta a velocidad urbana, sin tráfico. Pulse un trayecto para comprobarlo en mapas.",
roadNote: "El desplazamiento es el tiempo habitual por carretera, sin tráfico en tiempo real. Pulsa un trayecto para comprobarlo en el mapa.",
short: "{{duration}} de desplazamiento",
shortEstimated: "unos {{duration}} de desplazamiento",
},
week: {
legend: {
work: "Trabajo",
travel: "Desplazamiento",
free: "Libre",
overtime: "Fuera de horario",
},
openDayA11y: "Planificar el {{day}}",
cellA11y: "{{name}}, {{day}}: {{percent}} % planificado, {{work}} de trabajo, {{travel}} de desplazamiento",
cellOffA11y: "{{name}}, {{day}}: no trabaja",
percent: "{{percent}} %",
free: "Libre",
hoursUnknown: "Horario desconocido",
unplannedDue: "Sin planificar, vencen",
forecast: "Con trabajo previsto",
forecastOver: "Excede en {{duration}}",
forecastFits: "Cabe",
},
panel: {
assignedTo: "Asignado a",
nobody: "Nadie todavía. Elija quién lo hace.",
partArrives: "Si la pieza llega el",
planFromThen: "Planificar desde entonces",
makeRoom: "Hacer sitio",
makeRoomHint: "Esto cae sobre otra visita. Ofrecer a esa visita otro lugar.",
day: "Día",
start: "Inicio",
length: "Duración",
ends: "Termina a las {{time}}",
notPlanned: "Sin planificar",
moreNotes_one: "{{count}} nota más",
moreNotes_many: "{{count}} notas más",
moreNotes_other: "{{count}} notas más",
fewerNotes: "Menos notas",
staged: "Aún sin guardar",
fixed: "Este trabajo ha empezado o está confirmado, así que se queda donde está.",
awaitingApproval: "Pendiente de aprobación. Todavía no se puede planificar.",
previousDayA11y: "El día anterior",
nextDayA11y: "El día siguiente",
earlierA11y: "Empezar 15 minutos antes",
laterA11y: "Empezar 15 minutos después",
shorterA11y: "15 minutos menos",
longerA11y: "15 minutos más",
remove: "Quitar del plan",
pin: "Fijar esta hora",
unpin: "Liberar la hora",
undo: "Deshacer cambio",
open: "Abrir",
closeA11y: "Cerrar el panel del plan",
},
apply: {
changes_one: "{{count}} cambio sin guardar",
changes_many: "{{count}} cambios sin guardar",
changes_other: "{{count}} cambios sin guardar",
notifies: "Al aplicar se avisa a {{names}}",
discard: "Descartar",
apply: "Aplicar",
breaks: "Incumple una regla: {{rules}}",
reasonLabel: "Motivo para seguir adelante",
reload: "Recargar",
done: "Plan guardado",
conflict: "Otra persona cambió {{days}} mientras planificaba. Recargue para verlo. Sus cambios se conservan.",
failed_one: "{{count}} cambio no se pudo guardar: {{message}}",
failed_many: "{{count}} cambios no se pudieron guardar. El primero: {{message}}",
failed_other: "{{count}} cambios no se pudieron guardar. El primero: {{message}}",
error: "No se pudo guardar el plan. {{message}}",
partial: "{{applied}} de {{requested}} cambios aplicados",
none_one: "No se pudo aplicar el cambio",
none_many: "No se pudo aplicar ninguno de los {{count}} cambios",
none_other: "No se pudo aplicar ninguno de los {{count}} cambios",
unsettled: "Los cambios se escribieron, pero no se pudo confirmar el resultado. Recarga para comprobar el plan.",
reviewIssues_one: "Revisar {{count}} problema",
reviewIssues_many: "Revisar {{count}} problemas",
reviewIssues_other: "Revisar {{count}} problemas",
issues: {
title: "Cambios que no se aplicaron",
appliedLine_one: "{{count}} cambio aplicado",
appliedLine_many: "{{count}} cambios aplicados",
appliedLine_other: "{{count}} cambios aplicados",
retry: "Reintentar los fallidos",
keep: "Conservar los aplicados",
discardRest: "Descartar el resto",
open: "Abrir",
closeA11y: "Cerrar la revisión de cambios no aplicados",
code: {
refused: "No permitido",
not_persisted: "No se guardó",
unverified: "No se pudo comprobar que se guardó",
missing: "Ya no existe",
},
},
recover: "Una actualización anterior del plan no terminó.",
recoverAction: "Revisar",
recovered: {
applied: "La actualización anterior se había aplicado por completo.",
failed: "No se había aplicado nada de la actualización anterior.",
},
stale: "Alguien cambió {{days}} después de sus cambios. Revise el tablero y luego conserve o descarte sus cambios.",
staleAction: "Conservar mis cambios",
overrideNote: "{{rule}}, anulado: {{reason}}",
},
optimise: {
action: "Sugerir un plan",
title: "Plan sugerido",
whatIfA11y: "¿Y si {{name}} no está?",
whyShow: "Por qué este plan",
whyHide: "Ocultar los motivos",
scenarioOff: "¿Y si {{name}} no está?",
scenarioArrival: "¿Y si la pieza llega el {{date}}?",
scenarioNote: "Solo una vista previa. Nada cambia hasta que pulse Usar este plan.",
working: "Calculando el plan… {{seconds}} s",
stop: "Detener",
useScenario: "Usar este plan",
closeA11y: "Cerrar el plan sugerido",
removeA11y: "Dejar {{title}} como está",
why: {
placed: "Planificado por estos motivos: {{list}}.",
held: "Sigue sin planificar: {{list}}.",
reason: "{{count}} × {{reason}}",
blocker: "{{count}} × {{reason}}",
join: " · ",
},
whyReason: {
required_skill: "la habilidad requerida",
parts_ready: "piezas listas",
due_today: "vence ese día",
urgent: "alta prioridad",
near_previous: "cerca de la parada anterior",
same_site: "ya en el sitio",
keeps_assignee: "sigue con la misma persona",
saves_travel: "ahorra desplazamiento",
after_overrun: "tras el retraso",
from_position: "desde donde está",
overtime: "fuera de la jornada",
with_crew: "con el equipo",
via_pickup: "pasando por una recogida",
swapped: "intercambiado entre personas",
fits_capacity: "cabe en el día",
},
extraPerson: "¿Y si hubiera una persona más?",
extraPersonTakes_one: "Una persona más asumiría {{count}} visita más.",
extraPersonTakes_many: "Una persona más asumiría {{count}} visitas más.",
extraPersonTakes_other: "Una persona más asumiría {{count}} visitas más.",
extraPersonNone: "Una persona más no cambiaría el plan.",
none: "Nada que mejorar: el plan ya encaja.",
planned: "Planificado {{before}} → {{after}}",
travel: "Desplazamiento {{before}} → {{after}}",
stillUnplanned_one: "{{count}} sigue sin planificar",
stillUnplanned_many: "{{count}} siguen sin planificar",
stillUnplanned_other: "{{count}} siguen sin planificar",
confidence: {
high: "Confianza alta",
medium: "Confianza media",
low: "Confianza baja",
},
note: {
parts_unknown_one: "Piezas sin confirmar para {{count}} visita",
parts_unknown_many: "Piezas sin confirmar para {{count}} visitas",
parts_unknown_other: "Piezas sin confirmar para {{count}} visitas",
location_missing_one: "{{count}} visita no tiene ubicación",
location_missing_many: "{{count}} visitas no tienen ubicación",
location_missing_other: "{{count}} visitas no tienen ubicación",
duration_default_one: "{{count}} visita usa una duración estimada",
duration_default_many: "{{count}} visitas usan una duración estimada",
duration_default_other: "{{count}} visitas usan una duración estimada",
travel_estimated_one: "Desplazamiento estimado para {{count}} trayecto",
travel_estimated_many: "Desplazamiento estimado para {{count}} trayectos",
travel_estimated_other: "Desplazamiento estimado para {{count}} trayectos",
},
reason: {
required_skill: "Tiene la habilidad requerida",
parts_ready: "Piezas listas",
due_today: "Vence ese día",
urgent: "Prioridad alta",
near_previous: "A {{duration}} de la parada anterior",
same_site: "Ya está en este sitio",
fits_capacity: "Cabe en el día",
keeps_assignee: "Sigue con la misma persona",
saves_travel: "Ahorra {{duration}} de desplazamiento",
after_overrun: "Empieza cuando el trabajo anterior pueda terminar",
from_position: "Empieza cuando la persona puede llegar desde donde está",
overtime: "{{duration}} más allá de la jornada",
with_crew: "Planificado con el equipo a la misma hora",
via_pickup: "Pasa por la recogida de la pieza",
swapped: "Intercambiado con otra persona, ahorra {{duration}}",
},
},
schedulePlan: {
save: "Guardar plan",
failed: "No se pudo guardar. {{message}}",
},
myDay: {
  boardHint: "Aquí puede ver el día de todo el equipo. Para mover trabajo entre personas en el tablero del día, abra Trabajo en una tableta o un ordenador.",
  title: "Mi día",
saved: "Guardado {{time}} · sin conexión, se muestra la última copia",
savedWide: "Guardado {{time}} · no se pudo conectar con el servidor, se muestra la última copia. Hasta entonces no se puede aplicar nada.",
changed: "Tu plan cambió mientras tanto: {{moved}} movidos, {{added}} nuevos, {{removed}} eliminados.",
changedDismissA11y: "Cerrar la nota sobre los cambios",
mine: "Mi día",
everyone: "Todos",
switchA11y: "De quién es el día que se muestra",
accept: "Aceptar",
decline: "Rechazar",
accepted: "Aceptado",
acceptFailed: "No se pudo aceptar. {{message}}",
startNext: "Empezar lo siguiente: {{title}}",
},
insights: {
eyebrow: "Planificación del trabajo",
title: "Cómo va el plan",
subtitle: "Los últimos {{days}} días",
none: "—",
utilisation: "Trabajando, no conduciendo",
utilisationCaption: "del tiempo planificado",
utilisationInfo: "Trabajo como proporción de trabajo más desplazamiento en todos los días planificados del periodo. El desplazamiento nunca es tiempo productivo.",
adherence: "Empezadas según el plan",
adherenceCaption_one: "de {{count}} visita planificada",
adherenceCaption_many: "de {{count}} visitas planificadas",
adherenceCaption_other: "de {{count}} visitas planificadas",
adherenceInfo: "Visitas planificadas que empezaron dentro de los {{minutes}} minutos de su hora planificada.",
actual: "Duración real vs planificada",
actualCaption_one: "mediana de {{count}} visita",
actualCaption_many: "mediana de {{count}} visitas",
actualCaption_other: "mediana de {{count}} visitas",
actualInfo: "Cuánto duraron realmente las visitas terminadas como proporción de la duración planificada. 100 % es según el plan; más significa que los planes se quedan cortos.",
},
directions: {
action: "Cómo llegar",
route: "Ruta",
routeA11y: "Abrir la ruta de {{name}} en mapas",
legA11y: "Abre este trayecto en mapas",
partsTitle: "Esta ruta se abre por partes",
partsBody: "Un enlace de mapas admite un número limitado de paradas. Elija la parte que quiere abrir.",
part: "Paradas {{from}}–{{to}}",
cancel: "Cancelar",
},
map: {
show: "Mapa",
hide: "Tablero",
hideNarrow: "Lista",
empty: "Nada de lo planificado este día tiene ubicación.",
unplannedNearby_one: "{{count}} sin planificar, con ubicación",
unplannedNearby_many: "{{count}} sin planificar, con ubicación",
unplannedNearby_other: "{{count}} sin planificar, con ubicación",
stopA11y: "Parada {{number}}: {{title}}",
noLocation_one: "{{count}} sin ubicación",
noLocation_many: "{{count}} sin ubicación",
noLocation_other: "{{count}} sin ubicación",
legend: "Las líneas discontinuas unen las paradas en orden. No son la carretera.",
},
home: {
title: "Plan de hoy",
count_one: "{{count}} visita",
count_many: "{{count}} visitas",
count_other: "{{count}} visitas",
withNext_one: "{{count}} visita · siguiente {{time}} {{title}}",
withNext_many: "{{count}} visitas · siguiente {{time}} {{title}}",
withNext_other: "{{count}} visitas · siguiente {{time}} {{title}}",
},
settings: {
title: "Ajustes de planificación",
closeA11y: "Cerrar los ajustes de planificación",
week: "Semana laboral",
starts: "El día empieza",
ends: "El día termina",
break: "Descanso",
noBreak: "Ninguno",
defaults: "Cuando nadie lo indicó",
jobLength: "Una orden de trabajo dura",
inspectionLength: "Una inspección dura",
citySpeed: "Conducción en ciudad",
citySpeedHint: "Se usa para estimar el desplazamiento cuando no hay un tiempo por carretera. Los trayectos largos se suponen más rápidos.",
save: "Guardar",
failed: "No se pudo guardar. {{message}}",
person: "Para {{name}}",
personHours: "Su horario",
ownHours: "Propio",
sameHours: "El del espacio de trabajo",
personDepot: "Dónde empieza y termina su día",
savePerson: "Guardar para esta persona",
overtime: "Los planes sugeridos pueden exceder la jornada en",
noOvertime: "Nunca",
overtimeHint: "Los planes sugeridos lo evitan cuando pueden. Un cambio más allá del día se marca y necesita un motivo antes de aplicarlo.",
depot: "Dónde empieza y termina el día",
noDepot: "Sin definir",
depotHint: "Un sitio. El primer y el último desplazamiento del día cuentan desde aquí.",
usePositions: "Usar dónde está cada persona",
usePositionsHint: "Cada persona decide si comparte su ubicación, y solo mientras la aplicación está abierta. Solo los propietarios y administradores la ven, para detectar retrasos. Solo se guarda la última ubicación, durante dos horas.",
clearDepot: "Quitar",
lessA11y: "Menos: {{label}}",
moreA11y: "Más: {{label}}",
timeOff: "Ausencias el {{day}}",
removeOffA11y: "Quitar la ausencia de {{name}}",
off: {
allDay: "Todo el día",
morning: "Mañana",
afternoon: "Tarde",
},
},
parts: {
title: "Piezas necesarias",
empty: "No hay piezas indicadas. Añada lo que alguien debe llevar.",
addLabel: "Pieza o material",
add: "Añadir pieza",
removeA11y: "Quitar {{part}}",
failed: "No se pudo guardar la pieza. {{message}}",
availability: {
unknown: "Sin confirmar",
available: "Disponible",
reserved: "Reservada",
unavailable: "No disponible",
},
heldAt: "Guardada en {{site}}",
notHeld: "¿Dónde está guardada?",
clearHeld: "Quitar",
},
jobPlanning: {
title: "Planificación",
people: "Personas a la vez",
fewerA11y: "Menos personas",
moreA11y: "Más personas",
appointment: "Debe ocurrir entre",
on: "El",
from: "Desde",
to: "Hasta",
saveAppointment: "Guardar franja",
clearAppointment: "Quitar franja",
window: "{{on}}, {{from}}–{{to}}",
noWindow: "Cualquier hora",
waitsOn: "Espera a",
waitsOnNone: "Nada",
removeDepA11y: "Ya no espera a {{title}}",
addDepA11y: "Esperar a {{title}}",
failed: "No se pudo guardar. {{message}}",
},
refine: {
planningTitle: "Planificación",
partsTitle: "Piezas",
planning: {
planned: "Planificado",
unplanned: "Sin planificar",
blocked: "Bloqueado",
},
parts: {
ready: "Listas",
unavailable: "No disponibles",
unknown: "Sin confirmar",
},
},
lanes: {
a11y: "Las columnas muestran",
people: "Por persona",
site: "Por sitio",
asset: "Por activo",
noSite: "Sin sitio",
noAsset: "Sin activo",
},
review: {
overrun: "{{title}} lleva {{duration}} de retraso. El resto del día de {{name}} ya no encaja.",
absence_one: "{{name}} está ausente en {{count}} visita planificada.",
absence_many: "{{name}} está ausente en {{count}} visitas planificadas.",
absence_other: "{{name}} está ausente en {{count}} visitas planificadas.",
urgent_one: "{{count}} trabajo urgente está sin planificar.",
urgent_many: "{{count}} trabajos urgentes están sin planificar.",
urgent_other: "{{count}} trabajos urgentes están sin planificar.",
part_unavailable: "Una pieza para {{title}} ya no está disponible.",
cancelled: "{{title}} se canceló: su hora queda libre.",
early_finish: "{{name}} terminó {{title}} antes de tiempo: hay tiempo para más.",
running_late: "{{name}} llegará unos {{duration}} tarde a {{title}}, desde donde está.",
more: "+{{count}} más",
action: "Revisar el plan",
dismissA11y: "Dejar a un lado",
nothing: "No se puede mover nada para resolverlo. Hay que decidirlo a mano.",
},
position: {
  stop: "Dejar de compartir",
  share: "Compartir ubicación",
sharingShort: "Compartiendo su ubicación",
stopA11y: "Dejar de compartir su ubicación",
offer: "Comparta dónde está mientras trabaja, para que su día pueda ajustarse si va con retraso.",
explainTitle: "¿Compartir dónde está?",
explain: "Mientras esta aplicación esté abierta y tenga trabajo hoy, su ubicación se envía cada pocos minutos. Solo los propietarios y administradores de su espacio de trabajo la ven, para detectar cuándo llegará tarde a su próxima visita. Solo se guarda la última ubicación, se borra a las dos horas y puede dejar de compartir en cualquier momento.",
explainConfirm: "Compartir con la aplicación abierta",
explainCancel: "Ahora no",
denied: "La ubicación está desactivada para esta aplicación. Permítala en los ajustes del dispositivo para compartir dónde está.",
failed: "No se pudo cambiar el uso compartido. {{message}}",
fromYou: "Unos {{duration}} desde usted hasta {{title}}",
seen: "Visto hace {{duration}}",
seenNow: "Visto ahora mismo",
},
slot: {
createA11y: "Crear trabajo a las {{time}}",
clear: "Sin choques con su día",
},
rail: {
allDay: "Todo el día",
forecast: "Previsión",
forecastA11y: "Previsión, aún sin reservar: {{title}}",
},
agenda: {
empty: "No hay nada planificado para este día. Las flechas cambian de día.",
},
error: {
  tryAgain: "Inténtelo de nuevo en un momento.",
  offline: "Compruebe su conexión e inténtelo de nuevo.",
  notAllowed: "No tiene permiso para cambiar esto.",
load: "No se pudo cargar el plan.",
retry: "Reintentar",
},
loadingA11y: "Cargando el plan",
truncated: "En estos días hay más trabajo del que carga el calendario. Acótelo con Refinar.",
},
scheduler: {
  contractor: {
    giveNow: "Asignar al contratista",
    pick: "Elegir un contratista",
    change: "{{name}} · Cambiar",
    hint: "La recibe en Mi trabajo y necesita una cuenta de AssetWRX. Usted la sigue firmando.",
    missing: "Elija el contratista al que va esta inspección.",
  },
  fitLine: {
    bestAvailable: "Mejor opción disponible",
    goodFit: "Buena opción",
    line: "Mejor opción: {{name}} · {{score}} % de idoneidad · {{why}}",
  },
  fitReason: {
    certification: "Tiene una certificación requerida",
    withinRange: "A una distancia razonable",
    closeToSite: "Cerca del sitio",
    available: "Marcado como disponible",
    team: "En el equipo responsable de este trabajo",
    capacity: "Tiene tiempo libre",
    lightlyBooked: "Solo {{n}} h programadas",
    nothingBooked: "Nada programado",
    onTime: "Suele terminar a tiempo",
    verifiedHistory: "Su trabajo suele verificarse",
    assetTypeExperience: "Experiencia con este tipo de activo",
    priorWorkOnAsset: "Ya ha trabajado en este activo",
    skillsMatch: "Tiene las habilidades que requiere el trabajo",
    categoryMany: "{{n}} trabajos completados en esta categoría",
    categoryOne: "1 trabajo completado en esta categoría",
  },
  blocker: {
    not_assignable: "No se le puede asignar trabajo",
    inactive_contractor: "El contratista no está activo",
    no_site_access: "Sin acceso a este sitio",
    unavailable: "No disponible a esa hora",
    missing_certification: "Le falta una certificación requerida",
    missing_mandatory_skill: "Le falta una habilidad requerida",
  },
  slotReason: {
    afterDue: "Después de la fecha límite",
    sameSite: "Mismo sitio que el trabajo anterior",
    beforeDue: "Antes de la fecha límite",
    minutes: "{{n}} min",
    hours: "{{n}} h",
    gapFree: "Hueco libre de {{duration}}",
    firstGap: "Primer hueco libre de {{duration}}",
  },
  notes: {
    revert: "Revertir",
    discard: "Descartar",
    accept: "Aceptar",
    tidyFailedTitle: "No se pudo mejorar la nota",
    tidiedReview: "Revísala y toca Aceptar.",
    tidiedTitle: "Nota mejorada",
    tidyUp: "Mejorar con IA",
    stop: "Detener",
    dictate: "Dictar",
  },
  assignee: {
    noMatch: "Nadie de tu equipo coincide.",
    search: "Buscar en tu equipo",
    blocked: "no disponible",
    contractor: "Contratista",
    technician: "Técnico",
    notEligibleItem: "{{name}} ({{reason}})",
    notEligible: "No puede hacerlo: {{list}}",
    bestMatch: "Mejor opción: {{name}}",
    assignA11y: "Asignar a {{name}}",
    recommended: "Recomendado: {{name}}",
    youSuffix: "{{name}} (tú)",
    you: "Tú",
  },
  invite: {
    description: "Lista de verificación: {{checklist}}",
    title: "Inspección: {{asset}}",
  },
  errors: {
    photosOtherWorkspace: "Tus fotos se guardan para el espacio de trabajo donde creaste esta orden de trabajo. Vuelve a él y toca Terminar de guardar.",
    otherWorkspace: "Vuelve al espacio de trabajo donde creaste esta orden de trabajo y toca Terminar de guardar.",
    pickTime: "Elige una fecha y una hora e inténtalo de nuevo.",
  },
  errorTitles: {
    reschedule: "La nueva hora no se guardó",
    jobLater: "La orden de trabajo no se programó",
    jobNow: "La orden de trabajo no se creó",
    inspectionLater: "La inspección no se programó",
    inspectionNow: "La inspección no se inició",
  },
  checklist: {
    noMatch: "Ninguna lista coincide. Prueba otra palabra o toca Nueva lista de verificación.",
    search: "Buscar listas de verificación",
    add: "Añadir",
    done: "Listo",
    change: "Cambiar",
    picked: "Elegiste esta.",
    loadFailed: "Tus listas de verificación no se cargaron.",
    loading: "Cargando listas de verificación…",
  },
  slotAfterDue: "después de la fecha límite",
  moreSummaryShort: "Cómo realizarla y recordatorios",
  renewing: "Renovando {{title}}. Esta inspección registra las pruebas de la renovación.",
  renewingJob: "Renovando {{title}}. Cuando termine esta orden de trabajo, cree a partir de ella el certificado de reemplazo.",
  renewJobTitle: "Renovar {{title}}",
  fromRequest: "De la solicitud: {{title}}",
  runMode: {
    list: "Lista",
    guided_group: "Por sección",
    guided_item: "Paso a paso",
  },
  reminder: {
    "2day": "2 días antes",
    "1day": "1 día antes",
    "2hr": "2 horas antes",
    "1hr": "1 hora antes",
    "30min": "30 minutos antes",
    "15min": "15 minutos antes",
    at_time: "A la hora prevista",
  },
  cta: {
    scheduleJob: "Programar orden de trabajo",
    scheduleInspection: "Programar inspección",
    createJob: "Crear orden de trabajo",
    startInspection: "Iniciar inspección",
    saveTime: "Guardar nueva hora",
    finishJob: "Terminar de guardar",
  },
  heading: {
    job: "Orden de trabajo · {{asset}}",
    inspection: "Inspección · {{asset}}",
    rescheduleJob: "Reprogramar orden de trabajo",
    rescheduleInspection: "Reprogramar inspección",
  },
  done: {
    jobCreated: "Orden de trabajo creada para {{asset}}.",
    jobScheduled: "Orden de trabajo para {{asset}} programada para el {{when}}.",
    jobCreatedPhotos: "Orden de trabajo creada. Fotos guardadas en este dispositivo para subirlas.",
    jobRescheduled: "Orden de trabajo para {{asset}} movida al {{when}}.",
    open: "Abrir",
    inspectionRepeats: "Inspección de {{asset}} programada para el {{when}}. Se repite: {{how}}.",
    inspectionScheduled: "Inspección de {{asset}} programada para el {{when}}. Aparece en Trabajo ese día.",
    inspectionRescheduled: "Inspección de {{asset}} movida al {{when}}.",
  },
  hide: "Ocultar",
  moreSummary: "Cómo hacerlo, recordatorios, notas y quién lo hace",
  errorBody: "No se ha guardado nada. Compruebe la conexión e inténtelo de nuevo.",
  errorPartialTitle: "Orden de trabajo creada; guardado incompleto",
  repeat: {
    advance: {
      on_calendar: "En las fechas previstas",
      on_completion: "Después de terminar esta",
    },
    nextFrom: "¿Cuándo toca la siguiente?",
    noLimit: "Sin límite",
    maxTimes: "Parar tras (veces)",
    use: "Usar {{how}}",
    suggested: "Sugerencia: {{how}}. {{why}}",
    planHint: "Para repetir según la lectura del contador o en fechas fijas, añada en su lugar un plan de mantenimiento en el activo.",
    errorMax: "Indique cuántas veces o déjelo en blanco.",
    errorEndBeforeStart: "La repetición no puede terminar antes de la primera visita.",
    errorEnd: "Elija el día en que termina la repetición.",
  },
show: "Mostrar",
},
workItemCopy: {
issues_one: "{{count}} problema",
issues_many: "{{count}} de problemas",
issues_other: "{{count}} problemas",
inspectionFallback: "Inspección",
},
assistantCards: {
draftFindingPhoto: "Redactar un hallazgo a partir de la foto",
suggestTriagePriority: "Sugerir una prioridad de triaje",
recurringRaisesPriority: "Un problema recurrente elevaría la prioridad.",
suggestRepair_one: "Sugerir una reparación para {{count}} elemento fallido",
suggestRepair_many: "Sugerir una reparación para {{count}} de elementos fallidos",
suggestRepair_other: "Sugerir una reparación para {{count}} elementos fallidos",
checkExistingRepair: "Revise primero la reparación existente — puede ser un duplicado.",
draftFindingEvidence: "Redactar un hallazgo a partir de las pruebas",
suggestPriority: "Sugerir una prioridad",
suggestContractor: "Sugerir el contratista más adecuado",
contractorRecurring: "Un mismo contratista sigue resolviendo trabajos en este activo.",
verifyEvidence: "Verificar las pruebas de finalización",
suggestFollowUp: "Sugerir una acción de seguimiento",
verifyBeforeSignOff: "Verificar las pruebas de finalización antes de aprobar",
summariseJourney: "Resumir el recorrido para el informe",
summarisePortfolio: "Resumir el recorrido de la cartera",
portfolioRisk: "Riesgo {{band}} de la cartera ({{score}}/100)",
riskBandLow: "bajo",
riskBandMedium: "medio",
riskBandHigh: "alto",
},
evidenceLocal: {
identifierVin: "VIN {{value}}",
identifierSerial: "N.º de serie {{value}}",
identifierOther: "Identificador {{value}}",
codes_one: "{{count}} código",
codes_many: "{{count}} de códigos",
codes_other: "{{count}} códigos",
readings_one: "{{count}} lectura",
readings_many: "{{count}} de lecturas",
readings_other: "{{count}} lecturas",
complianceLabel: "etiqueta {{scheme}}",
dates_one: "{{count}} fecha",
dates_many: "{{count}} de fechas",
dates_other: "{{count}} fechas",
recognised: "Se reconoció {{label}}. No se encontraron datos estructurados en el dispositivo.",
nothingFound: "No se extrajo información en el dispositivo.",
found: "Encontrado en el dispositivo: {{parts}}.",
separator: ", ",
mobileOnly: "El análisis en el dispositivo se realiza en la aplicación móvil.",
failed: "No se pudieron analizar las pruebas en el dispositivo.",
},
fitRisks: {
missesDueDates: "Suele incumplir las fechas de vencimiento",
repeatReopens: "Reaperturas repetidas en trabajos recientes",
someRework: "Algo de retrabajo en órdenes de trabajo anteriores",
hoursCommitted_one: "{{count}} h ya comprometida",
hoursCommitted_many: "{{count}} h ya comprometidas",
hoursCommitted_other: "{{count}} h ya comprometidas",
heavyWorkload: "Carga de trabajo actual muy alta",
elevatedWorkload: "Carga de trabajo activa elevada",
overdueAssignments_one: "{{count}} asignación vencida",
overdueAssignments_many: "{{count}} de asignaciones vencidas",
overdueAssignments_other: "{{count}} asignaciones vencidas",
},
journeySignals: {
whereAsset: "en este activo",
wherePortfolio: "en toda la cartera",
alreadyRepairedLabel: "Ya se ha completado una reparación {{where}}.",
alreadyRepairedDetailAgo_one: "La orden de trabajo completada más reciente {{where}} se cerró hace {{count}} d — compruebe que no sea un duplicado antes de crear trabajo nuevo.",
alreadyRepairedDetailAgo_many: "La orden de trabajo completada más reciente {{where}} se cerró hace {{count}} d — compruebe que no sea un duplicado antes de crear trabajo nuevo.",
alreadyRepairedDetailAgo_other: "La orden de trabajo completada más reciente {{where}} se cerró hace {{count}} d — compruebe que no sea un duplicado antes de crear trabajo nuevo.",
alreadyRepairedDetail: "Ya existe una orden de trabajo completada {{where}} — compruebe que no sea un duplicado antes de crear trabajo nuevo.",
recurringLabel_one: "Se ha registrado {{count}} orden de trabajo o hallazgo independiente {{where}}.",
recurringLabel_many: "Se han registrado {{count}} de órdenes de trabajo o hallazgos independientes {{where}}.",
recurringLabel_other: "Se han registrado {{count}} órdenes de trabajo o hallazgos independientes {{where}}.",
recurringDetail_one: "{{count}} elemento de trabajo {{where}} llegó a orden de trabajo o hallazgo en los últimos {{days}} días — un activo con mantenimiento repetido puede merecer un análisis de la causa raíz en lugar de otra reparación puntual.",
recurringDetail_many: "{{count}} de elementos de trabajo {{where}} llegaron a orden de trabajo o hallazgo en los últimos {{days}} días — un activo con mantenimiento repetido puede merecer un análisis de la causa raíz en lugar de otra reparación puntual.",
recurringDetail_other: "{{count}} elementos de trabajo {{where}} llegaron a orden de trabajo o hallazgo en los últimos {{days}} días — un activo con mantenimiento repetido puede merecer un análisis de la causa raíz en lugar de otra reparación puntual.",
contractorLabel_one: "{{name}} ha resuelto {{count}} orden de trabajo {{where}}.",
contractorLabel_many: "{{name}} ha resuelto {{count}} de órdenes de trabajo {{where}}.",
contractorLabel_other: "{{name}} ha resuelto {{count}} órdenes de trabajo {{where}}.",
contractorDetail: "Las visitas repetidas del mismo contratista pueden indicar una causa raíz sin resolver.",
healthLabel_one: "La salud del activo está empeorando (ha bajado {{count}} punto).",
healthLabel_many: "La salud del activo está empeorando (ha bajado {{count}} de puntos).",
healthLabel_other: "La salud del activo está empeorando (ha bajado {{count}} puntos).",
healthDetail: "La salud operativa bajó de {{then}} a {{now}} — priorice este activo antes de que llegue a la banda Acción.",
overdueLabel_one: "{{count}} seguimiento abierto {{where}} está vencido.",
overdueLabel_many: "{{count}} de seguimientos abiertos {{where}} están vencidos.",
overdueLabel_other: "{{count}} seguimientos abiertos {{where}} están vencidos.",
overdueDetail: "Los recorridos abiertos {{where}} han incumplido al menos un SLA de etapa — corren el riesgo de retrasarse aún más.",
},
suggestJobCopy: {
noInspectionData: "No se han proporcionado datos de inspección para sugerir órdenes de trabajo.",
noSuggestions: "No hay sugerencias de órdenes de trabajo para esta inspección.",
suggestionsReady_one: "{{count}} sugerencia de orden de trabajo lista.",
suggestionsReady_many: "{{count}} de sugerencias de órdenes de trabajo listas.",
suggestionsReady_other: "{{count}} sugerencias de órdenes de trabajo listas.",
addRequestSummary: "Añada un resumen de la solicitud para sugerir una orden de trabajo.",
derivedFromRequest: "Sugerencia de orden de trabajo obtenida de la solicitud.",
derivedWarning: "Obtenida de la solicitud (sin IA). Confírmela antes de crear la orden de trabajo.",
enableAi: "Active la IA para sugerir una orden de trabajo de seguimiento.",
enableAiHint: "Use la IA para generar una sugerencia de orden de trabajo de seguimiento.",
offline: "La sugerencia de IA no está disponible sin conexión.",
offlineWarning: "Sugerencia de IA no disponible sin conexión",
followUpFailed: "No se pudo sugerir una orden de trabajo de seguimiento.",
notAvailable: "Las sugerencias de órdenes de trabajo no están disponibles en este contexto.",
suggestionFailed: "Error en la sugerencia",
jobFailed: "No se pudo sugerir una orden de trabajo.",
},
rules: {
title: "Reglas de grupo",
subtitle: "Repetir una lista de verificación en muchos activos",
intro: "Una regla de grupo aplica la misma lista de verificación a cada activo que coincide, por ejemplo cada puerta cortafuegos del edificio A cada mes. Los activos nuevos que coinciden se suman solos.",
howTitle: "Cómo funcionan las reglas de grupo",
howStep1: "Elige el grupo: una clase de activo, uno de tus tipos de activo, un tipo de lugar o una zona. Puedes limitarlo a lo que hay dentro de un lugar.",
howStep2: "Elige la lista de verificación, la frecuencia y la fecha de la primera inspección.",
howStep3: "Al guardar se crea una inspección para cada activo del grupo. Un activo que se suma más tarde recibe la suya; si uno sale del grupo, se cancela su inspección no iniciada.",
howExample: "Ejemplo: «Revisión mensual de puertas cortafuegos» toma cada puerta cortafuegos del edificio A. Al guardar se crean 24 inspecciones para la primera fecha. En la página Trabajo aparecen como una sola fila.",
howEdits: "Editar una regla actualiza sus inspecciones no iniciadas. Las inspecciones iniciadas o terminadas nunca cambian. Detener una regla cancela las que no se han iniciado.",
howTour: "Muéstrame",
howGuide: "Leer la guía",
add: "Añadir regla de grupo",
newTitle: "Nueva regla de grupo",
editTitle: "Editar regla de grupo",
nameLabel: "Nombre",
namePlaceholder: "Revisión mensual de puertas cortafuegos",
nameRequired: "Ponle un nombre a la regla",
whatLabel: "Qué activos",
whatHint: "Elige primero una clase de activo.",
anyPlace: "Cualquier lugar",
whereLabel: "Dónde",
whereHint: "Dentro de un lugar incluye todo lo que contiene, a cualquier nivel: las plantas de un edificio, sus salas y lo que está instalado en ellas.",
anywhere: "En cualquier sitio",
aPlace: "un lugar",
someType: "Un tipo de activo",
anyAsset: "Cualquier activo",
inZone: "en la zona {{zone}}",
insidePlace: "dentro de {{place}}",
assignedTo: "a {{name}}",
zoneLabel: "Zona (opcional)",
zoneHint: "Solo activos con esta zona.",
checklistLabel: "Lista de control",
pickChecklist: "Elegir una lista de verificación",
checklistRequired: "Elige una lista de verificación",
searchChecklists: "Buscar listas de verificación",
howOftenLabel: "Frecuencia",
startsOnLabel: "Primera inspección el",
startsOnInvalid: "Escribe la fecha como AAAA-MM-DD",
assigneeLabel: "Asignar a (opcional)",
assigneeHint: "Se le avisa una sola vez, sin importar cuántas inspecciones cree la regla.",
nobody: "Nadie todavía",
someone: "Alguien",
you: "{{name}} (tú)",
searchPeople: "Buscar personas",
needsGroup: "Elige una clase de activo, un tipo de activo, un tipo de lugar o una zona.",
sentence: "{{recurrence}} desde el {{date}}: cada {{what}}{{where}} recibe la lista de verificación «{{checklist}}».",
sentenceNoChecklist: "{{recurrence}} desde el {{date}}: cada {{what}}{{where}}. Elige una lista de verificación para terminar.",
sentenceNeedsGroup: "Indica qué activos para ver la regla aquí.",
sentenceInside: " dentro de {{place}}",
sentenceInZone: " en la zona {{zone}}",
sentenceAssigned: "Asignada a {{name}}.",
counting: "Contando…",
estimate_one: "Ahora toma {{count}} activo.",
estimate_many: "Ahora toma {{count}} activos.",
estimate_other: "Ahora toma {{count}} activos.",
estimateHint: "Un activo que se suma al grupo más tarde recibe su propia inspección, con vencimiento el día en que se suma.",
estimateOffline: "Contado con los activos de este dispositivo porque no se pudo conectar con el servidor. La regla cubre igualmente cada coincidencia.",
editUpdates_one: "Al guardar se actualiza {{count}} inspección no iniciada.",
editUpdates_many: "Al guardar se actualizan {{count}} inspecciones no iniciadas.",
editUpdates_other: "Al guardar se actualizan {{count}} inspecciones no iniciadas.",
editLeaving_one: "Se cancelará {{count}} inspección: su activo ya no está en el grupo.",
editLeaving_many: "Se cancelarán {{count}} inspecciones: sus activos ya no están en el grupo.",
editLeaving_other: "Se cancelarán {{count}} inspecciones: sus activos ya no están en el grupo.",
editJoining_one: "Se creará {{count}} inspección nueva.",
editJoining_many: "Se crearán {{count}} inspecciones nuevas.",
editJoining_other: "Se crearán {{count}} inspecciones nuevas.",
editKept: "Las inspecciones iniciadas o terminadas no cambian.",
cancel: "Cancelar",
save: "Guardar regla",
saved_one: "Guardado. {{count}} inspección planificada.",
saved_many: "Guardado. {{count}} inspecciones planificadas.",
saved_other: "Guardado. {{count}} inspecciones planificadas.",
failedTitle: "No se pudo guardar la regla",
failedBody: "Comprueba tu conexión e inténtalo de nuevo.",
active: "Activa",
stopped: "Detenida",
savedMoreComing_one: "Guardado. {{count}} inspección planificada hasta ahora; el resto se añade o actualiza en los próximos minutos.",
savedMoreComing_many: "Guardado. {{count}} inspecciones planificadas hasta ahora; el resto se añade o actualiza en los próximos minutos.",
savedMoreComing_other: "Guardado. {{count}} inspecciones planificadas hasta ahora; el resto se añade o actualiza en los próximos minutos.",
moreComing: "Todavía se están añadiendo o actualizando inspecciones. Vuelve en unos minutos.",
openVisits_one: "{{count}} inspección abierta",
openVisits_many: "{{count}} inspecciones abiertas",
openVisits_other: "{{count}} inspecciones abiertas",
fromRuleLabel: "De una regla de grupo",
edit: "Editar",
stop: "Detener",
restart: "Reiniciar",
stopConfirmTitle: "¿Detener esta regla?",
stopConfirmBody_one: "Se cancelará su {{count}} inspección no iniciada. Las inspecciones terminadas se conservan.",
stopConfirmBody_many: "Se cancelarán sus {{count}} inspecciones no iniciadas. Las inspecciones terminadas se conservan.",
stopConfirmBody_other: "Se cancelarán sus {{count}} inspecciones no iniciadas. Las inspecciones terminadas se conservan.",
emptyTitle: "Aún no hay reglas de grupo",
emptyBody: "Las configura un propietario o administrador. Sus inspecciones aparecen luego en la página Trabajo como cualquier otra.",
emptyBodyAdmin: "Añade tu primera regla para inspeccionar todo un grupo de activos con un mismo calendario.",
foldedRow_one: "{{name}} · {{count}} activo",
foldedRow_many: "{{name}} · {{count}} activos",
foldedRow_other: "{{name}} · {{count}} activos",
},
rounds: {
title: "Empezar una ronda",
intro: "Un trabajo que recorre los lugares y elementos dentro de {{place}}. Cada parada tiene su propia lista de verificación.",
stopsLabel: "Paradas",
stopCount_one: "{{count}} parada",
stopCount_many: "{{count}} paradas",
stopCount_other: "{{count}} paradas",
all: "Todas",
none: "Ninguna",
loading: "Leyendo lo que hay dentro…",
tooMany: "Una ronda puede tener como máximo {{max}} paradas. Desmarca algunas.",
titleLabel: "Nombre de la ronda",
defaultTitle: "Ronda de {{checklist}}: {{place}}",
dateLabel: "Fecha (opcional)",
dateHint: "AAAA-MM-DD. Déjala vacía para planificarla más tarde.",
description_one: "Ronda de {{count}} parada en {{place}}.",
description_many: "Ronda de {{count}} paradas en {{place}}.",
description_other: "Ronda de {{count}} paradas en {{place}}.",
create_one: "Empezar ronda con {{count}} parada",
create_many: "Empezar ronda con {{count}} paradas",
create_other: "Empezar ronda con {{count}} paradas",
created_one: "Ronda empezada con {{count}} parada",
created_many: "Ronda empezada con {{count}} paradas",
created_other: "Ronda empezada con {{count}} paradas",
failedTitle: "No se pudo empezar la ronda",
failedBody: "No se creó nada. Comprueba tu conexión e inténtalo de nuevo.",
emptyTitle: "Aquí no hay nada que visitar",
emptyBody: "Añade primero lugares o equipos dentro de este lugar, o cambia los filtros.",
},
};
